import React, { useState, useEffect, useRef } from 'react';
import ErpTemplate from '../../../components/ErpTemplate';
import { FaArrowLeft, FaThumbsUp, FaThumbsDown, FaSearch, FaSave, FaArrowRight, FaCircle, FaUsers, FaFileInvoice, FaEye, FaEyeSlash, FaPlaneDeparture, FaPlaneArrival, FaTable, FaPlane, FaHotel, FaPlaneSlash, FaBed, FaTicketAlt, FaExchangeAlt, FaStickyNote, FaColumns, FaHistory, FaSync, FaExclamationTriangle } from 'react-icons/fa';
import api from '../../../services/api';
import ModalForcarEnvio from '../../../components/ModalForcarEnvio';
import { useCartaFila, BadgeCartaFila, PERFIS_FILA } from '../../../components/CartaFilaStatus';
import { useHistory, useLocation } from 'react-router-dom';
import { dataMysql, buscarCep, data, extract, dataHoraMysql, hora, dataHora, atualizarLogomarcaEvento, getOpcaoIda, idaCompleta, retornoCompleto, getOpcaoRetorno, compareIda, compareRetorno, idaTemDados, retornoTemDados, formatCrm, isTipoHcp, isNaoFarmaceutico, categoriaTiposParticipante, CARGO_OUTROS, CATEGORIA_NAO_FARMACEUTICO } from '../../../util/util';
import Data from '../../../components/Data';
import ReactSelect from '../../../components/ReactSelect';
import InputMask from 'react-input-mask';
import { toast } from 'react-toastify';
import { FinField, FinInput, FinNumber, FinTextarea, FinCheck, FinChecks } from '../../../components/FinField';
import moment from 'moment';
import { RiMailSendLine } from 'react-icons/ri';
import FormButton from '../../../components/FormButton';
import Alert from '../../../components/Alert';
import NavItem from '../../../components/NavItem';
import TabelaHistoricoParticipante from '../../../components/TabelaHistoricoParticipante';
import LocalAereo from '../../../components/LocalAereo';
import '../../../css/financeiro-parcela-pagar.css';

const OPCOES_HOSPEDAGEM = [
    { value: 'nao', label: 'Não' },
    { value: 'sim', label: 'Sim' },
    { value: 'cld', label: 'Cancelado' },
];

const OPCOES_AEREO = [
    { value: 'nao', label: 'Não' },
    { value: 'sim', label: 'Sim' },
    { value: 'cld', label: 'Cancelado' },
];

const OPCOES_INSCRICAO = [
    { value: 'nao', label: 'Não' },
    { value: 'sim', label: 'Sim' },
    { value: 'cld', label: 'Cancelado' },
];

const OPCOES_TRANSFER = [
    { value: 'nao', label: 'Não' },
    { value: 'sim', label: 'Sim' },
    { value: 'cld', label: 'Cancelado' },
];

const OPCOES_CARTA = [
    { value: '', label: 'Todas' },
    { value: 'confirmada', label: 'Confirmada' },
    { value: 'naoconfirmada', label: 'Não Confirmada' },
];

// estado do atendimento na fila. O participante NÃO sai mais da lista ao mudar de status —
// ele só troca de aba aqui, quando o operador conclui.
const OPCOES_ATENDIMENTO = [
    { value: 'pendentes', label: 'Pendentes' },
    { value: 'feitos', label: 'Concluídos' },
    { value: 'todos', label: 'Todos' },
];

const OPCOES_UF = [
    { value: "AC", label: "AC" }, { value: "AL", label: "AL" }, { value: "AP", label: "AP" },
    { value: "AM", label: "AM" }, { value: "BA", label: "BA" }, { value: "CE", label: "CE" },
    { value: "DF", label: "DF" }, { value: "ES", label: "ES" }, { value: "GO", label: "GO" },
    { value: "MA", label: "MA" }, { value: "MT", label: "MT" }, { value: "MS", label: "MS" },
    { value: "MG", label: "MG" }, { value: "PA", label: "PA" }, { value: "PB", label: "PB" },
    { value: "PR", label: "PR" }, { value: "PE", label: "PE" }, { value: "PI", label: "PI" },
    { value: "RJ", label: "RJ" }, { value: "RN", label: "RN" }, { value: "RS", label: "RS" },
    { value: "RO", label: "RO" }, { value: "RR", label: "RR" }, { value: "SC", label: "SC" },
    { value: "SP", label: "SP" }, { value: "SE", label: "SE" }, { value: "TO", label: "TO" },
];

export default function CadastroEventoParticipanteOperador({ match }) {
    const id = match.params.id;
    const usuario = localStorage.getItem("idUsuario");
    const token = localStorage.getItem('token');

    // Modal de envio imediato: aberto quando o back recusa por a carta ja estar na fila.
    const [forcarEnvio, setForcarEnvio] = useState({ show: false, mensagem: '', reenviar: null });



    /**
     * Dispara a informativa deste participante.
     *
     * Dois avisos, sempre nesta ordem e nunca no mesmo passo:
     *
     *   1. dados faltantes / reenvio - pre-checagem do back, que e fail-all: nada saiu
     *      ainda. Confirmar repete a chamada com `confirmarEnvio`.
     *   2. carta ja enfileirada - modal de bypass da fila, o ultimo antes de sair.
     *      Confirmar repete com `forcarEnvio`.
     *
     * As flags sao cumulativas de proposito: forcar a fila depois de ja ter confirmado
     * dados faltantes precisa mandar as duas, senao a pre-checagem barra de novo e o
     * operador volta ao inicio do fluxo.
     *
     * Cada aviso sai por um `return`: enquanto ha o que confirmar nao ha desfecho para
     * anunciar, e o toast de sucesso diria que a carta entrou na fila antes de entrar.
     */
    const enviarInformativaRequest = (idParticipante, { confirmar = false, forcar = false } = {}) => {
        api({
            method: 'post',
            action: '/eventoCarta/enviarCartaInformativa',
            token: token,
            data: {
                idParticipantes: idParticipante,
                confirmarEnvio: confirmar,
                forcarEnvio: forcar,
            },
        })
            .then(function (response) {
                const d = response.data.data;

                // Recusa do back (token expirado) vem 200 com `mensagem` e nada mais: sem isto
                // nenhum contador existe, `erros` fica vazio e o clique nao produz reacao
                // nenhuma na tela — que e exatamente o estado que faz o operador clicar de novo.
                if (d.quantidadeSucesso === undefined && d.mensagem) {
                    toast.error(d.mensagem);
                    return;
                }

                const errosIncompletos = (d.erros ?? []).filter(e => e.tipo === 'rsvp_incompleto');
                const errosReenvio = (d.erros ?? []).filter(e => e.tipo === 'reenvio');
                const outrosErros = (d.erros ?? []).filter(e => !['rsvp_incompleto', 'reenvio'].includes(e.tipo));

                if (errosIncompletos.length > 0 || errosReenvio.length > 0) {
                    //o html do Alert vai pra innerHTML: nome de participante e digitado pelo usuario
                    const esc = (valor) => String(valor ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
                    const blocos = errosIncompletos.map(e => {
                        const grupos = e.campos_faltantes ?? {};
                        const bullets = Object.keys(grupos)
                            .map(g => `<li><strong>${esc(g)}:</strong> ${(grupos[g] ?? []).map(esc).join(', ')}</li>`)
                            .join('');
                        return `<div style="margin-bottom:8px;text-align:left"><strong style="color:#333;display:block;margin-bottom:2px;text-align:center">Participante ${esc(e.participante)}:</strong><ul style="text-align:left;margin:4px 0 0;padding-left:18px">${bullets}</ul></div>`;
                    }).join('');
                    const blocosReenvio = errosReenvio
                        .map(e => `<li><strong>${esc(e.participante)}</strong> — enviada em ${esc(e.enviadaem)}</li>`)
                        .join('');
                    // Havendo reenvio, a confirmação fala de reenvio mesmo que haja dados faltantes
                    // junto — senão o operador confirma achando que é o primeiro envio.
                    const temReenvio = errosReenvio.length > 0;
                    const soReenvio = temReenvio && errosIncompletos.length === 0;
                    const rotuloConfirmar = temReenvio ? 'Reenviar mesmo assim.' : 'Enviar mesmo assim.';

                    Alert({
                        icon: "warning",
                        title: soReenvio ? "Reenvio de Carta Informativa" : (temReenvio ? "Confirme o envio" : "Dados incompletos no cadastro"),
                        html: (errosIncompletos.length > 0
                            ? `A Carta Informativa possui dados faltantes:<br><br>${blocos}`
                            : '')
                            + (errosReenvio.length > 0
                                ? `<p style="margin:8px 0 4px;text-align:left">Já recebeu a Carta Informativa:</p>`
                                + `<ul style="text-align:left;margin:4px 0 0;padding-left:18px">${blocosReenvio}</ul>`
                                : '')
                            + `<hr style="margin:12px 0" />`
                            + `<h5 style="color:#e74c3c;margin:0 0 6px;text-align:left">Atenção:</h5>`
                            + `<p style="margin:0 0 8px;text-align:left">Nenhum e-mail foi enviado ainda. Confirme o envio da carta informativa:</p>`,
                        input: "checkbox",
                        inputPlaceholder: rotuloConfirmar,
                        inputValidator: (value) => {
                            if (!value) {
                                return `Marque "${rotuloConfirmar}" para confirmar o envio.`;
                            }
                        },
                        confirmButton: temReenvio ? "Confirmar reenvio" : "Confirmar envio",
                        cancelButton: "Cancelar",
                        callBack: (resultado) => {
                            if (resultado.isConfirmed && resultado.value) {
                                enviarInformativaRequest(idParticipante, { confirmar: true, forcar: forcar });
                            }
                        },
                    });

                    return;
                }

                if (d.podeForcar) {
                    setForcarEnvio({
                        show: true,
                        mensagem: d.mensagem,
                        reenviar: () => enviarInformativaRequest(idParticipante, { confirmar: confirmar, forcar: true }),
                    });

                    return;
                }

                if (d.quantidadeSucesso > 0 || d.enfileirados > 0 || d.jaNaFila > 0) {
                    // Entrou na fila, ainda nao saiu - o texto vem do back para nao haver duas versoes.
                    toast.success(d.mensagem);
                    recarregarParticipanteAtual(idParticipante);
                    // A carta acabou de entrar na fila deste evento. Sem isto o hook so
                    // consultaria de novo se `emAndamento` ja fosse true — e com a fila vazia
                    // na abertura da tela ele consulta uma vez e para, entao a marca do topo
                    // nunca apareceria justamente para a carta que o operador mandou aqui.
                    // O envio acabou de recarregar os dados desta tela: a marca vai sumir no proximo
                    // poll e a transicao dispararia o banner "a tela mostra os valores de antes"
                    // segundos depois de ela ter sido atualizada. Zera a sentinela antes.
                    tinhaCartaNaFila.current = 0;
                    setCartaSaiuDaFila(false);
                    recarregarFila();
                }

                outrosErros.forEach(function (erro) {
                    if (erro.mensagem) {
                        toast.error(erro.mensagem);
                    }
                });
            })
            .catch(function (error) {
                toast.error('Erro: ' + (error.response?.data?.error ?? " ao carregar dados"));
            });
    };

    /** Confirmacao inicial do botao Enviar Informativa. */
    const enviarInformativa = () => {
        Alert({
            icon: "question",
            confirmButton: <><FaThumbsUp size={20} /> Enviar</>,
            denyButton: <><FaThumbsDown size={20} /> Sair</>,
            title: "Enviar Carta Informativa?",
            callBack: (result) => {
                if (result.isConfirmed) {
                    enviarInformativaRequest(dados.participante?.id ?? null);
                }
            },
        });
    };

    /**
     * Dispara o convite deste participante. Envio individual sai no mesmo request; havendo
     * carta ja enfileirada, o back recusa e devolve `podeForcar`, e a tela oferece o envio
     * imediato.
     */
    const enviarConviteRequest = (idParticipante, forcar) => {
        api({
            method: 'post',
            action: '/eventoCarta/enviarCartaConvite',
            token: token,
            data: { idParticipantes: idParticipante, forcarEnvio: forcar },
        })
            .then(function (response) {
                const retorno = response.data.data;

                // Recusa do back (token expirado) vem 200 com `mensagem` e nada mais: sem isto
                // nenhum contador existe, `erros` fica vazio e o clique nao produz reacao
                // nenhuma na tela — que e exatamente o estado que faz o operador clicar de novo.
                if (retorno.quantidadeSucesso === undefined && retorno.mensagem) {
                    toast.error(retorno.mensagem);
                    return;
                }

                if (retorno.podeForcar) {
                    setForcarEnvio({ show: true, mensagem: retorno.mensagem, reenviar: () => enviarConviteRequest(idParticipante, true) });
                    return;
                }

                if (retorno.quantidadeSucesso > 0 || retorno.enfileirados > 0 || retorno.jaNaFila > 0) {
                    toast.success(retorno.mensagem);
                }
                (retorno.erros ?? []).forEach(function (erro) {
                    toast.error(erro.mensagem);
                });
                // O envio individual carimba data e situacao no proprio request, entao este
                // recarregamento volta a re-sincronizar a trava de concorrencia. No caso em
                // massa, quem carimba e o processamento da fila, minutos depois.
                recarregarParticipanteAtual(idParticipante);
                // A carta acabou de entrar na fila deste evento. Sem isto o hook so
                // consultaria de novo se `emAndamento` ja fosse true — e com a fila vazia
                // na abertura da tela ele consulta uma vez e para, entao a marca do topo
                // nunca apareceria justamente para a carta que o operador mandou aqui.
                // O envio acabou de recarregar os dados desta tela: a marca vai sumir no proximo
                // poll e a transicao dispararia o banner "a tela mostra os valores de antes"
                // segundos depois de ela ter sido atualizada. Zera a sentinela antes.
                tinhaCartaNaFila.current = 0;
                setCartaSaiuDaFila(false);
                recarregarFila();
            })
            .catch(function (error) {
                toast.error('Erro: ' + (error.response?.data?.error ?? " ao carregar dados"));
            });
    };
    const [tableSelect, setTableSelect] = useState({});
    const [filtro, setFiltro] = useState({});
    const [tableActions, setTableActions] = useState([]);
    const [selectEventos, setSelectEventos] = useState({
        eventoSelecionado: null,
        listaEventos: [
            {
                value: null,
                label: 'Buscando...'
            }
        ]
    });
    const [dados, setDados] = useState({
        posicao: 0,
        participante: {
            nome: 'buscando...',
        }
    });

    // Carta na fila deste participante: a marca no topo evita que o operador dispare
    // de novo achando que o clique anterior nao saiu.
    //
    // Depois do useState de `dados`, e nao junto do token: `dados` e const, entao le-lo
    // antes da declaracao estoura ReferenceError e derruba a tela no ErrorBoundary.
    // So consulta quem enxerga a marca: para os demais o back recusa e a chamada so serve
    // para pausar o hook.
    const { fila, recarregarFila } = useCartaFila(
        PERFIS_FILA.includes(localStorage.getItem('perfil')) ? dados.participante?.evento?.id : null,
        token
    );
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [dadosTotais, setDadosTotais] = useState([]);
    // ramo não farmacêutico: sem CRM/conselho/especialidade, com Cargo.
    // No evento "Ambos" o ramo segue o tipo do participante
    const naoFarmaceutico = isNaoFarmaceutico(dados.participante?.evento, dados.participante?.tipoparticipante ?? '');
    const categoriaTipos = categoriaTiposParticipante(dados.participante?.evento);
    const funcaoDados = () => dados;
    const funcaoFiltro = () => filtro;
    const [dadosModalHistorico, setDadosModalHistorico] = useState({});
    const [historico, setHistorico] = useState([]);
    // loading do refetch do participante (recarregarParticipanteAtual) após ações sibling — mostra o overlay do ErpTemplate
    const [isLoading, setIsLoading] = useState(false);
    // Trava de concorrência: guarda o updated_at do participante no momento do load para
    // detectar no back se alguém (ex.: o convidado escolhendo voo) alterou o registro antes de salvar.
    const baseUpdatedAtRef = useRef(null);
    const history = useHistory();
    const params = new URLSearchParams(window.location.search);
    const idCliente = params.get('idCliente');
    const nomeCliente = params.get('nomeCliente');
    const [tab, setTab] = useState('colunasnomeaveis');
    const [verCrmOriginal, setVerCrmOriginal] = useState(false);

    const preencherCep = (cep, dadosAtuais) => {
        buscarCep(cep).then((resposta) => {
            if (!resposta.erro) {
                dadosAtuais.participante.enderecobairro = resposta.bairro;
                dadosAtuais.participante.enderecocomplemento = resposta.complemento;
                dadosAtuais.participante.enderecologradouro = resposta.logradouro;
                dadosAtuais.participante.enderecopais = "30";
                dadosAtuais.participante.nomeEnderecopais = "Brasil";
                dadosAtuais.participante.enderecomunicipio = resposta.ibge;
                dadosAtuais.participante.nomeEnderecomunicipio = resposta.localidade;
                setDados({ ...dadosAtuais });
            }
        });
    }
    const buscarHistorico = (idParticipante) => {
        // Loading proprio, e nao o do ErpTemplate: recarregar so o historico nao pode
        // cobrir a tela inteira e travar o formulario que o operador esta usando.
        setCarregandoHistorico(true);

        api({
            method: "get",
            action: '/participanteHistoricoSituacao',
            token: token,
            params: { participante: idParticipante }
        }).then(response => {
            var dadosRecebidosHistorico = response.data.data;
            setHistorico(dadosRecebidosHistorico);
        }).catch(err => {
            //console.log(err)
        }).finally(() => {
            setCarregandoHistorico(false);
        });
    };

    // recarrega o participante ATUAL por id após uma ação sibling (mudar situação / enviar carta)
    // que avança o updated_at. Reflete os carimbos/situação no form E renova a trava de concorrência
    // — mesma UX do buscar() da tela de cadastro, mas por id: NÃO usa o buscar() daqui (que recarrega
    // por POSIÇÃO da fila e pularia pra outro participante) nem mexe em fila/posição/totais. Evita
    // STALE_WRITE (409) no próximo salvar.
    const recarregarParticipanteAtual = (idParticipante) => {
        if (!idParticipante) {
            return;
        }
        setIsLoading(true);
        api({
            method: "get",
            action: '/participante/' + idParticipante,
            token: token,
        }).then(response => {
            if (!response.data.data) {
                return;
            }
            var dadosParticipante = extract({
                jsonLaravel: response.data.data,
                chaves: [
                    'enderecopais',
                    'aereomunicipioembarque',
                    'enderecomunicipio',
                    'tipoparticipante',
                    'cargoparticipante',
                ]
            });
            dados.participante = dadosParticipante;
            // o GET do participante já traz o vínculo (`with('eventooperador.operador')`), então
            // o estado do atendimento acompanha o refetch de graça. É o que evita o botão dizer
            // "Concluir" depois de um declínio, que o backend conclui sozinho
            dados.vinculo = dadosParticipante.eventooperador ?? null;
            dados.atendimentoConcluido = (dados.vinculo?.feito ?? 'nao') === 'sim'; //valor do switch
            baseUpdatedAtRef.current = dadosParticipante.updated_at ?? null; // versão carregada (trava de concorrência)
            dados.participante.hoteldatacheckin = data(dadosParticipante.hoteldatacheckin);
            dados.participante.hoteldatacheckout = data(dadosParticipante.hoteldatacheckout);
            dados.participante.datanascimento = data(dadosParticipante.datanascimento);
            dados.participante.dataopcaoaereo = data(dadosParticipante.dataopcaoaereo);
            dados.participante.horacartainformativa = hora(dadosParticipante.datacartainformativa);
            dados.participante.datacartainformativa = data(dadosParticipante.datacartainformativa);
            dados.participante.dataconfirmacaocartainformativa = data(dadosParticipante.dataconfirmacaocartainformativa);
            dados.participante.horacartaconvite = hora(dadosParticipante.datacartaconvite);
            dados.participante.datacartaconvite = data(dadosParticipante.datacartaconvite);
            dados.participante.horacartaassinada = hora(dadosParticipante.datacartaassinada);
            dados.participante.datacartaassinada = data(dadosParticipante.datacartaassinada);
            dados.participante.dataconfirmacaodados = data(dadosParticipante.dataconfirmacaodados);
            dados.participante.horaescolhaaereo = hora(dadosParticipante.dataescolhaaereo);
            dados.participante.dataescolhaaereo = data(dadosParticipante.dataescolhaaereo);
            dados.participante.datainscricao = data(dadosParticipante.datainscricao);
            dados.participante.horacertificado = hora(dadosParticipante.datacertificado);
            dados.participante.datacertificado = data(dadosParticipante.datacertificado);
            dados.participante.nomeIdioma = dadosParticipante.idioma?.nome;
            dados.participante.idioma = dadosParticipante.idioma?.codigo;
            setDados({ ...dados });
            if (dadosParticipante.enderecomunicipio?.uf) {
                setDados(prevDados => ({
                    ...prevDados,
                    participante: {
                        ...prevDados.participante,
                        enderecouf: dadosParticipante.enderecomunicipio.uf
                    }
                }));
            }
            buscarHistorico(dadosParticipante.id);
        }).catch(() => { }).finally(() => {
            setIsLoading(false);
        });
    };

    // Conclui ou reabre o atendimento do participante que está na tela.
    // Substitui o antigo `feito = 'sim'` automático do registro de histórico: concluir NÃO
    // desfaz o vínculo — o participante continua com o mesmo operador, só sai dos pendentes.
    //
    // Não é ação imediata: é chamada pelo Salvar, e só quando o switch mudou em relação ao
    // que foi carregado. Devolve promise para o Salvar poder encadear.
    const gravarConclusaoSeMudou = () => {
        const idParticipante = dados.participante?.id;
        // o vínculo já traz o evento como id cru nos dois payloads; o participante só traz
        // dentro do objeto da relação, que dependeria de `evento` nunca entrar no extract()
        const idEvento = dados.vinculo?.evento ?? dados.participante?.evento?.id;
        const concluir = dados.atendimentoConcluido === true;
        const jaEstavaConcluido = (dados.vinculo?.feito ?? 'nao') === 'sim';

        if (!dados.vinculo || !idParticipante || !idEvento || concluir === jaEstavaConcluido) {
            return Promise.resolve(false);
        }

        return api({
            method: 'put',
            action: '/evento/concluirParticipanteOperador/' + idEvento + '/' + idParticipante,
            token: token,
            data: { feito: concluir ? 'sim' : 'nao' }
        })
            .then(function () {
                toast.success(concluir ? 'Atendimento concluído!' : 'Atendimento reaberto!');
                return true;
            })
            .catch(function (error) {
                toast.error('Dados salvos, mas o atendimento não foi atualizado: ' + (error.response?.data?.error ?? ''));
                return false;
            });
    };

    // devolve a promise para quem precisa esperar o recarregamento terminar
    const buscar = (tipo = 'posicao') => {
        var eventoFiltro = selectEventos.eventoSelecionado ? selectEventos.eventoSelecionado : null;
        if (["cliente"].includes(tipo)) {
            eventoFiltro = null;
        }
        return api({
            method: "get",
            action: '/buscarParticipanteOperador/' + usuario,
            token: token,
            params: {
                cliente: funcaoFiltro().cliente ?? null,
                posicao: ["posicao", "cliente"].includes(tipo) ? dados.posicao : null,
                eventoSelecionado: eventoFiltro,
                evento: tipo === 'evento' ? selectEventos.eventoSelecionado : null,
                situacao: funcaoFiltro().situacao ?? null,
                situacaocartaconvite: funcaoFiltro().situacaocartaconvite ?? null,
                situacaocartainformativa: funcaoFiltro().situacaocartainformativa ?? null,
                atendimento: funcaoFiltro().atendimento ?? 'pendentes',
            }
        }).then(response => {
            if (response.data.data.participante) {
                //dados do participante
                var dadosParticipante = extract({
                    jsonLaravel: response.data.data.participante,
                    chaves: [
                        'enderecopais',
                        'aereomunicipioembarque',
                        'enderecomunicipio',
                        'tipoparticipante',
                        'cargoparticipante',
                    ]
                });
                dados.participante = dadosParticipante;
                baseUpdatedAtRef.current = dadosParticipante.updated_at ?? null; // versão carregada (trava de concorrência)
                dados.participante.hoteldatacheckin = data(dadosParticipante.hoteldatacheckin);
                dados.participante.hoteldatacheckout = data(dadosParticipante.hoteldatacheckout);
                dados.participante.datanascimento = data(dadosParticipante.datanascimento);
                dados.participante.dataopcaoaereo = data(dadosParticipante.dataopcaoaereo);
                dados.participante.horacartainformativa = hora(dadosParticipante.datacartainformativa);
                dados.participante.datacartainformativa = data(dadosParticipante.datacartainformativa);
                dados.participante.dataconfirmacaocartainformativa = data(dadosParticipante.dataconfirmacaocartainformativa);
                dados.participante.horacartaconvite = hora(dadosParticipante.datacartaconvite);
                dados.participante.datacartaconvite = data(dadosParticipante.datacartaconvite);
                dados.participante.horacartaassinada = hora(dadosParticipante.datacartaassinada);
                dados.participante.datacartaassinada = data(dadosParticipante.datacartaassinada);
                dados.participante.dataconfirmacaodados = data(dadosParticipante.dataconfirmacaodados);
                dados.participante.horaescolhaaereo = hora(dadosParticipante.dataescolhaaereo);
                dados.participante.dataescolhaaereo = data(dadosParticipante.dataescolhaaereo);
                dados.participante.datainscricao = data(dadosParticipante.datainscricao);
                dados.participante.horacertificado = hora(dadosParticipante.datacertificado);
                dados.participante.datacertificado = data(dadosParticipante.datacertificado);
                dados.participante.nomeIdioma = dadosParticipante.idioma?.nome;
                dados.participante.idioma = dadosParticipante.idioma?.codigo;
                dados.posicao = response.data.data.posicaoAtual;
                dados.vinculo = response.data.data.vinculo ?? null; //estado do atendimento
                dados.atendimentoConcluido = (dados.vinculo?.feito ?? 'nao') === 'sim'; //valor do switch

                atualizarLogomarcaEvento(dadosParticipante.evento ?? null);
                setDados({ ...dados });

                //verifica se existe UF no enderecomunicipio e atribui ao enderecouf
                if (dadosParticipante.enderecomunicipio?.uf) {
                    setDados(prevDados => ({
                        ...prevDados,
                        participante: {
                            ...prevDados.participante,
                            enderecouf: dadosParticipante.enderecomunicipio.uf
                        }
                    }));
                }

                //atualiza lista de historico do participante
                buscarHistorico(dadosParticipante.id);

                //atualiza lista de eventos a fazer
                setSelectEventos((atual) => ({
                    ...atual,
                    eventoSelecionado: response.data.data.eventoAtual,
                    listaEventos: response.data.data.listaEventos ?? [],
                }));

                //atualiza dados de Totais
                setDadosTotais(response.data.data.totais);
            } else {// nao achou
                dados.participante = null;
                dados.vinculo = null;
                dados.atendimentoConcluido = false;
                atualizarLogomarcaEvento();
                setDados({ ...dados });

                // a lista de eventos vem em TODA resposta: aplicada só quando havia participante, o
                // select ficava preso em "Buscando..." com a fila vazia — e sem fila não havia como
                // escolher outro evento para sair do vazio. O evento selecionado é preservado.
                setSelectEventos((atual) => ({
                    ...atual,
                    listaEventos: response.data.data.listaEventos ?? [],
                }));

                //atualiza dados de Totais
                setDadosTotais(response.data.data.totais);
            }
        }).catch(err => {
            atualizarLogomarcaEvento();
            //console.log(err)
        });
    };// buscar

    const salvarDadosParticipante = () => {
        let dadosParticipanteSalvar = { ...dados.participante }; //faz alterações antes de enviar para salvar
        if (dadosParticipanteSalvar.hoteldatacheckin) {
            dadosParticipanteSalvar.hoteldatacheckin = dataMysql(dadosParticipanteSalvar.hoteldatacheckin);
        }
        if (dadosParticipanteSalvar.hoteldatacheckout) {
            dadosParticipanteSalvar.hoteldatacheckout = dataMysql(dadosParticipanteSalvar.hoteldatacheckout);
        }
        if (dadosParticipanteSalvar.datanascimento) {
            dadosParticipanteSalvar.datanascimento = dataMysql(dadosParticipanteSalvar.datanascimento);
        }
        if (dadosParticipanteSalvar.dataopcaoaereo) {
            dadosParticipanteSalvar.dataopcaoaereo = dataMysql(dadosParticipanteSalvar.dataopcaoaereo);
        }
        if (dadosParticipanteSalvar.datacartainformativa) {
            dadosParticipanteSalvar.datacartainformativa = dataHoraMysql(dadosParticipanteSalvar.datacartainformativa + ' ' + dadosParticipanteSalvar.horacartainformativa);
        }
        if (dadosParticipanteSalvar.dataconfirmacaocartainformativa) {
            dadosParticipanteSalvar.dataconfirmacaocartainformativa = dataMysql(dadosParticipanteSalvar.dataconfirmacaocartainformativa);
        }
        if (dadosParticipanteSalvar.datacartaconvite) {
            dadosParticipanteSalvar.datacartaconvite = dataHoraMysql(dadosParticipanteSalvar.datacartaconvite + ' ' + dadosParticipanteSalvar.horacartaconvite);
        }
        if (dadosParticipanteSalvar.datacartaassinada) {
            dadosParticipanteSalvar.datacartaassinada = dataHoraMysql(dadosParticipanteSalvar.datacartaassinada + ' ' + dadosParticipanteSalvar.horacartaassinada);
        }
        if (dadosParticipanteSalvar.dataconfirmacaodados) {
            dadosParticipanteSalvar.dataconfirmacaodados = dataMysql(dadosParticipanteSalvar.dataconfirmacaodados);
        }
        if (dadosParticipanteSalvar.dataescolhaaereo) {
            dadosParticipanteSalvar.dataescolhaaereo = dataHoraMysql(dadosParticipanteSalvar.dataescolhaaereo + ' ' + dadosParticipanteSalvar.horaescolhaaereo);
        }
        if (dadosParticipanteSalvar.datainscricao) {
            dadosParticipanteSalvar.datainscricao = dataMysql(dadosParticipanteSalvar.datainscricao);
        }
        if (dadosParticipanteSalvar.datacertificado) {
            dadosParticipanteSalvar.datacertificado = dataHoraMysql(dadosParticipanteSalvar.datacertificado + ' ' + dadosParticipanteSalvar.horacertificado);
        }

        //bugfix vem como array (remove pra nao alterar)
        delete dadosParticipanteSalvar.situacaoevento;
        delete dadosParticipanteSalvar.evento;

        // trava de concorrência: manda a versão carregada para o back barrar escrita desatualizada
        dadosParticipanteSalvar.baseUpdatedAt = baseUpdatedAtRef.current;

        api({
            method: 'put',
            action: '/participante/' + dadosParticipanteSalvar.id,
            token: token,
            data: dadosParticipanteSalvar,
        })
            .then(function (response) {
                toast.success('Dados registrados com sucesso!');
                // atualiza a versão base para os próximos salvamentos não caírem em falso positivo
                if (response?.data?.data?.updated_at) {
                    baseUpdatedAtRef.current = response.data.data.updated_at;
                }
                // o switch de atendimento concluído é gravado aqui, junto com o Salvar —
                // e só quando mudou. Se mudou, recarrega para refletir os carimbos novos
                return gravarConclusaoSeMudou().then(function (mudou) {
                    if (mudou) {
                        recarregarParticipanteAtual(dados.participante?.id);
                    }
                });
            })
            .catch(function (error) {
                if (error?.response?.status === 409 && error?.response?.data?.error === 'STALE_WRITE') {
                    toast.error('Esta tela foi carregada antes de uma atualização mais recente. Atualize a página e tente novamente.');
                } else {
                    // sem isso um erro de validação passava sem sinal nenhum, e o switch ficava
                    // ligado na tela divergindo do que está gravado
                    toast.error('Erro ao salvar: ' + (error?.response?.data?.error ?? 'tente novamente'));
                }
            });
    };//salvarDadosParticipante


    // Carta que sai da fila deixa a tela desatualizada: o envio muda a situacao do
    // participante, carimba a data da carta e escreve a linha de historico — tudo no
    // back, sem esta aba saber. Aqui a marca do topo deixa de existir, e e nesse
    // instante que recarregamos. `buscar()` ja traz o historico junto.
    //
    // So na transicao tinha -> nao tem. Recarregar a cada resposta do polling
    // atropelaria o que o operador estivesse digitando, de dez em dez segundos.
    const tinhaCartaNaFila = useRef(0);

    // Qual participante a sentinela acima esta observando. Sem isto ela atravessa a troca de
    // participante — na tela do operador o botao Proximo substitui `dados` sem desmontar, e o
    // poll seguinte anunciava "a carta saiu da fila e foi enviada" para quem nunca teve carta.
    const participanteObservado = useRef(null);

    const [cartaSaiuDaFila, setCartaSaiuDaFila] = useState(false);
    const [carregandoHistorico, setCarregandoHistorico] = useState(false);

    useEffect(() => {
        const alvo = dados.participante?.id ?? null;

        // Conta so o que esta VIVO. `porParticipante` traz tambem `falhou`, que e terminal e
        // fica ate um reenvio: olhar a presenca de qualquer entrada fazia o participante com
        // falha antiga nunca disparar o aviso, e a tela seguia com a situacao e a data de antes
        // ate o Salvar bater em STALE_WRITE. Compara quantidade, e nao existencia, para o
        // primeiro de dois envios vivos tambem ser anunciado.
        const vivasAgora = ((alvo && fila.porParticipante[alvo]) || [])
            .filter((e) => e.status === 'pendente' || e.status === 'processando').length;

        // Trocou de participante: re-semeia e nao avalia transicao nenhuma.
        if (participanteObservado.current !== alvo) {
            participanteObservado.current = alvo;
            tinhaCartaNaFila.current = vivasAgora;
            setCartaSaiuDaFila(false);

            return;
        }

        if (vivasAgora < tinhaCartaNaFila.current) {
            // Historico pode recarregar sozinho: e lista de leitura, nao ha nada do
            // operador ali para se perder.
            buscarHistorico(dados.participante?.id);

            // Os dados do cadastro NAO. `buscar()` substitui o formulario inteiro, e o
            // operador pode estar com campos preenchidos e nao salvos — recarregar aqui
            // apagaria o que ele digitou. Em vez disso avisamos, e ele decide quando.
            setCartaSaiuDaFila(true);
        }

        tinhaCartaNaFila.current = vivasAgora;
        // O id entra nas dependencias: sem ele a re-semeadura acima nunca dispara, porque
        // trocar de participante pelo Proximo nao muda `fila.porParticipante`. Com a fila ja
        // vazia o polling tambem parou, entao o banner de A ficava na tela de B ate um F5.
        // eslint-disable-next-line
    }, [fila.porParticipante, dados.participante?.id]);

    useEffect(() => { //onload
        atualizarLogomarcaEvento();
        if (idCliente) {
            filtro.cliente = idCliente;
            filtro.nomeCliente = nomeCliente;
            setFiltro({ ...filtro });
            setTimeout(() => {
                buscar('cliente');
            }, 500);
        } else {
            buscar();
        }
    },
        // eslint-disable-next-line
        []);

    const idaSalva = getOpcaoIda(dados.participante);
    const retornoSalva = getOpcaoRetorno(dados.participante);
    // o vínculo em tela é do usuário logado? só nesse caso o switch de conclusão aparece.
    // `operador` chega em dois formatos: id cru pelo buscarParticipanteOperador, e objeto da
    // relação pelo GET /participante (o with('eventooperador.operador') sobrescreve a coluna
    // homônima na serialização) — por isso o operador?.id antes do fallback
    const operadorDoVinculo = dados.vinculo?.operador?.id ?? dados.vinculo?.operador;
    const vinculoEhMeu = !!dados.vinculo && String(operadorDoVinculo ?? '') === String(usuario ?? '');

    return (
        <ErpTemplate processando={isLoading}>
            <div className="main-content container-fluid">

                {/* ── HEADER ── */}
                <div className="fin-pp__head">
                    <div>
                        <h2 className="fin-pp__title">
                            Participante — Operador
                            {dados.participante?.origemregistro === 'evento' ?
                                <span className="fin-pp__minitag is-warn" style={{ marginLeft: 8, verticalAlign: 'middle' }} title="Cadastrado durante o evento pela lista digital">Incluso no local</span>
                                : null}
                        </h2>
                        <p className="fin-pp__subtitle">
                            {dados.participante?.evento?.cliente?.nome
                                ? dados.participante.evento.cliente.nome + ' — '
                                : ''}
                            {dados.participante?.evento?.nome ?? ''}
                        </p>
                    </div>
                    <div className="fin-pp__actions">
                        {(dados.participante?.evento?.id && dados.participante?.id) &&
                            <NavItem to={"/cadastroEventoRsvpOpcaoAereo/" + dados.participante?.evento?.id + "?idParticipante=" + dados.participante?.id} icon={<FaPlane size={16} />} color="outline-dark">Opções de Aéreo</NavItem>
                        }
                        {dados.participante?.evento?.id &&
                            <NavItem
                                target="_blank"
                                to={{ pathname: "/eventoRelatorioParticipante/" + dados.participante?.evento?.id }}
                                icon={<FaTable size={16} />}
                                color="outline-dark">
                                Relatório de Participantes
                            </NavItem>
                        }
                    </div>
                </div>

                {/* Aviso em vez de recarregar sozinho: `buscar()` troca o formulario
                    inteiro e apagaria o que o operador tenha digitado e nao salvo. Quem
                    decide a hora e ele. O historico logo abaixo ja se atualizou sozinho,
                    porque ali nao ha nada dele para perder. */}
                {cartaSaiuDaFila ? (
                    <div className="fin-pp__banner is-warn">
                        <FaExclamationTriangle size={16} className="fin-pp__banner-ic" />
                        <span>
                            A carta deste participante saiu da fila e foi enviada. A situação e a data
                            da carta mudaram no servidor, e esta tela ainda mostra os valores de antes.
                            {' '}
                            <button
                                type="button"
                                className="fin-pp__btn fin-pp__btn--pill fin-pp__btn--sm"
                                style={{ marginLeft: 6 }}
                                onClick={() => {
                                    setCartaSaiuDaFila(false);

                                    // Por id, e NAO o buscar() desta tela, que recarrega por POSICAO da
                                    // fila de atendimento: com filtro de situacao ativo, a carta enviada
                                    // tira o participante do conjunto e a mesma posicao passa a ser outra
                                    // pessoa — o formulario trocaria e o Salvar seguinte gravaria em cima
                                    // dela. O comentario do recarregarParticipanteAtual avisa disso.
                                    recarregarParticipanteAtual(dados.participante?.id);
                                }}>
                                <FaSync size={13} /> Atualizar dados
                            </button>
                        </span>
                    </div>
                ) : null}


                {/* ── FILTROS DE BUSCA ── */}
                <div className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 16 }}>
                    <div className="fin-pp__cphead">
                        <span className="fin-pp__cphead-ic"><FaSearch size={15} /></span>
                        <span className="fin-pp__cphead-title">Buscar Participante</span>
                    </div>
                    <div className="fin-pp__filters">
                        <FinField label="Participante" full>
                            <ReactSelect
                                id="cliente"
                                value={{ value: filtro.cliente, label: filtro.nomeCliente }}
                                onChange={(e) => {
                                    filtro.cliente = e.value;
                                    filtro.nomeCliente = e.label;
                                    setFiltro({ ...filtro });
                                    setTimeout(() => {
                                        buscar('cliente');
                                    }, 500);
                                }}
                                loadOptions={(input) => {
                                    return api({
                                        method: 'get',
                                        action: '/participante',
                                        token: token,
                                        params: {
                                            nome: input,
                                            tipoCadastro: "participante",
                                            // este autocomplete só usa `evento.nome` — o pill de situação da tela vem do
                                            // /participante/{id}, não deste índice
                                            include: 'evento',
                                            situacaoRegistro: "ativo",
                                            limit: 30,
                                        }
                                    })
                                        .then(response => {
                                            let options = response.data.data.map((registro) => {
                                                var label = registro.codigo +
                                                    ' - ' + registro.nome +
                                                    (registro.cnpj ? ' (' + registro.cnpj + ')' : '') +
                                                    (registro.cpf ? ' (' + registro.cpf + ')' : '') +
                                                    (registro.nomefantasia ? ' - ' + registro.nomefantasia : '') +
                                                    (registro.evento ? ' | ' + registro.evento.nome : '');
                                                return {
                                                    value: registro.id,
                                                    label: label
                                                };
                                            });
                                            return options;
                                        })
                                        .catch(function (error) {
                                            //console.log(error);
                                        });
                                }}
                            />
                        </FinField>
                        <FinField label="Evento" full>
                            <ReactSelect
                                value={{ value: selectEventos.eventoSelecionado }}
                                onChange={(e) => {
                                    //limpa select cliente
                                    filtro.cliente = null;
                                    filtro.nomeCliente = null;
                                    setFiltro({ ...filtro });

                                    //seta select evento
                                    selectEventos.eventoSelecionado = e.value;
                                    setSelectEventos({ ...selectEventos });

                                    setTimeout(() => {
                                        buscar('evento');
                                    }, 500);
                                }}
                                options={selectEventos.listaEventos}
                            />
                        </FinField>
                        <FinField label="Status">
                            <ReactSelect
                                id="situacao"
                                value={{ value: filtro.situacao, label: filtro.nomeSituacao }}
                                onChange={(e) => {
                                    filtro.cliente = null;
                                    filtro.nomeCliente = null;
                                    filtro.situacao = e.value;
                                    filtro.nomeSituacao = e.label;
                                    setFiltro({ ...filtro });
                                    setTimeout(() => {
                                        buscar('evento');
                                    }, 500);
                                }}
                                loadOptions={(input) => {
                                    return api({
                                        method: 'get',
                                        action: '/eventoParticipanteSituacao',
                                        token: token,
                                        params: { situacaoRegistro: "ativo", nome: input }
                                    })
                                        .then(response => {
                                            let options = response.data.data.map(registro => ({ value: registro.id, label: registro.nome }));
                                            return [{ value: null, label: 'Todos' }, ...options];
                                        })
                                        .catch(function (error) {
                                            //console.log(error);
                                        });
                                }}
                            />
                        </FinField>
                        <FinField label="Atendimento">
                            <ReactSelect
                                id="atendimento"
                                value={{
                                    value: filtro.atendimento ?? 'pendentes',
                                    label: (OPCOES_ATENDIMENTO.find(opcao => opcao.value === (filtro.atendimento ?? 'pendentes')) ?? {}).label,
                                }}
                                onChange={(e) => {
                                    filtro.cliente = null;
                                    filtro.nomeCliente = null;
                                    filtro.atendimento = e.value;
                                    setFiltro({ ...filtro });
                                    setTimeout(() => {
                                        buscar('evento');
                                    }, 500);
                                }}
                                options={OPCOES_ATENDIMENTO}
                            />
                        </FinField>
                        <FinField label="Carta Convite">
                            <ReactSelect
                                value={{ value: filtro.situacaocartaconvite, label: filtro.nomeSituacaocartaconvite }}
                                onChange={(e) => {
                                    filtro.cliente = null;
                                    filtro.nomeCliente = null;
                                    filtro.situacaocartaconvite = e.value;
                                    filtro.nomeSituacaocartaconvite = e.label;
                                    setFiltro({ ...filtro });
                                    setTimeout(() => {
                                        buscar('evento');
                                    }, 500);
                                }}
                                options={OPCOES_CARTA}
                            />
                        </FinField>
                        <FinField label="Carta Informativa">
                            <ReactSelect
                                value={{ value: filtro.situacaocartainformativa, label: filtro.nomeSituacaocartainformativa }}
                                onChange={(e) => {
                                    filtro.cliente = null;
                                    filtro.nomeCliente = null;
                                    filtro.situacaocartainformativa = e.value;
                                    filtro.nomeSituacaocartainformativa = e.label;
                                    setFiltro({ ...filtro });
                                    setTimeout(() => {
                                        buscar('evento');
                                    }, 500);
                                }}
                                options={OPCOES_CARTA}
                            />
                        </FinField>
                    </div>
                </div>

                {/* ── TOTAIS ── */}
                {dadosTotais.length > 0 && (
                    <div className="fin-pp__card" style={{ padding: '10px 16px', marginBottom: 16 }}>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
                            {dadosTotais.map((elemento, i) => {
                                // Total e Feitos chegam do back em branco, cor do tema escuro antigo: no
                                // card claro o texto sumia. Esses dois usam as cores do `is-muted`; as
                                // situacoes seguem com a cor cadastrada.
                                const semCorPropria = String(elemento.cor ?? '').toUpperCase() === '#FFFFFF';
                                const estilo = semCorPropria
                                    ? { backgroundColor: 'var(--fin-bd)', color: 'var(--fin-mt)', borderColor: 'var(--fin-bd)' }
                                    : { backgroundColor: (elemento.cor ?? '#888') + '1f', color: elemento.cor ?? '#888', borderColor: (elemento.cor ?? '#888') + '55' };

                                return (
                                    <span key={i} className="fin-pp__tag" style={estilo}>
                                        <FaCircle size={10} style={{ marginRight: 4 }} />{elemento.titulo}: {elemento.quantidade}
                                    </span>
                                );
                            })}
                        </div>
                    </div>
                )}

                {/* ── NAVEGAÇÃO ANTERIOR/PRÓXIMO + AÇÕES DE CARTAS ── */}
                <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8, marginBottom: 16 }}>
                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                        {dados.posicao > 0 &&
                            <button type="button" className="fin-pp__btn fin-pp__btn--sm" onClick={() => {
                                dados.posicao = dados.posicao - 1;
                                setDados({ ...dados });
                                setTimeout(() => { buscar('posicao'); }, 500);
                            }}>
                                <FaArrowLeft size={14} style={{ marginRight: 4 }} />Anterior
                            </button>
                        }
                        <button type="button" className="fin-pp__btn fin-pp__btn--sm" onClick={() => {
                            dados.posicao = dados.posicao + 1;
                            setDados({ ...dados });
                            setTimeout(() => { buscar('posicao'); }, 500);
                        }}>
                            <FaArrowRight size={14} style={{ marginRight: 4 }} />Próximo
                        </button>
                        <button type="button" className="fin-pp__btn fin-pp__btn--sm" onClick={() => {
                            history.push({
                                pathname: "/eventoParticipante/" + dados.participante?.evento.id,
                                state: { operador: usuario }
                            });
                        }}>
                            <FaUsers size={14} style={{ marginRight: 4 }} />Lista de Participantes
                        </button>
                    </div>
                    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                        <FormButton
                            small={true}
                            method="post"
                            action={process.env.REACT_APP_API_URL + "/eventoCarta/visualizarCarta"}
                            icon={<FaEye size={16} />}
                            color="primary"
                            data={{
                                token: token,
                                tipoCarta: "modeloemailconvite",
                                idParticipantes: dados.participante?.id ?? null,
                                formato: "html"
                            }}
                        >Visualizar E-mail Convite</FormButton>
                        <FormButton
                            small={true}
                            method="post"
                            action={process.env.REACT_APP_API_URL + "/eventoCarta/visualizarCarta"}
                            icon={<FaEye size={16} />}
                            color="primary"
                            data={{
                                token: token,
                                tipoCarta: "modelocartaconvite",
                                idParticipantes: dados.participante?.id ?? null
                            }}
                        >Visualizar Carta Convite</FormButton>
                        <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--primary" onClick={() => {
                            Alert({
                                icon: "question",
                                confirmButton: <><FaThumbsUp size={20} /> Enviar</>,
                                denyButton: <><FaThumbsDown size={20} /> Sair</>,
                                title: "Enviar Carta Convite?",
                                callBack: (result) => {
                                    if (result.isConfirmed) {
                                        enviarConviteRequest(dados.participante?.id ?? null, false);
                                    }
                                }
                            });
                        }}>
                            <RiMailSendLine size={14} style={{ marginRight: 4 }} />Enviar Convite
                        </button>
                        <FormButton
                            small={true}
                            method="post"
                            action={process.env.REACT_APP_API_URL + "/eventoCarta/visualizarCarta"}
                            icon={<FaEye size={16} />}
                            color="primary"
                            data={{
                                token: localStorage.getItem('token'),
                                tipoCarta: "modeloemailinformativa",
                                idParticipantes: dados.participante?.id ?? null,
                                formato: "html"
                            }}
                        >Visualizar E-mail Informativa</FormButton>
                        <FormButton
                            small={true}
                            method="post"
                            action={process.env.REACT_APP_API_URL + "/eventoCarta/visualizarCarta"}
                            icon={<FaEye size={16} />}
                            color="primary"
                            data={{
                                token: localStorage.getItem('token'),
                                tipoCarta: "modelocarta",
                                idParticipantes: dados.participante?.id ?? null
                            }}
                        >Visualizar Carta Informativa</FormButton>
                        <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--primary" onClick={() => enviarInformativa()}>
                            <RiMailSendLine size={14} style={{ marginRight: 4 }} />Enviar Informativa
                        </button>
                    </div>
                </div>

                {/* ── FORMULÁRIO PRINCIPAL ── */}
                <form onSubmit={(e) => { salvarDadosParticipante(); e.preventDefault(); }}>

                    {/* ── DADOS DO PARTICIPANTE ── */}
                    <div className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 16 }}>
                        <div className="fin-pp__cphead">
                            <span className="fin-pp__cphead-ic"><FaUsers size={15} /></span>
                            <span className="fin-pp__cphead-title">Dados do Participante</span>
                            {/* Embrulhada so quando ha marca: o cabecalho tem `gap`, e um span vazio
                                ainda ocupa a vaga e empurra a pilula da situacao. Dentro dele as
                                marcas ficam no espacamento proprio, sem somar o gap do cabecalho. */}
                            {fila.porParticipante[dados.participante?.id]?.length ?
                                <span style={{ display: 'inline-flex', alignItems: 'center', flexWrap: 'wrap' }}>
                                    <BadgeCartaFila entradas={fila.porParticipante[dados.participante?.id]} variante="cabecalho" ritmo={fila.ritmo} />
                                </span>
                                : null}
                            {dados.participante?.situacaoevento?.nome &&
                                <span className="fin-pp__pill" style={{ backgroundColor: (dados.participante?.situacaoevento?.cor ?? '#888') + '1f', color: dados.participante?.situacaoevento?.cor ?? '#888', borderColor: (dados.participante?.situacaoevento?.cor ?? '#888') + '55', marginLeft: 8 }}>
                                    {dados.participante?.situacaoevento?.nome}
                                </span>
                            }
                            {/* Atendimento concluído é decisão do formulário, não ação imediata: o switch
                                só muda o estado local e o Salvar é que grava. Desligar e salvar reabre.
                                Só aparece no vínculo do PRÓPRIO usuário logado — chegando por busca por
                                nome ou pelo link do painel dá para abrir participante de outro operador,
                                e ninguém mexe no atendimento de ninguém. */}
                            {vinculoEhMeu ?
                                <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 8 }}>
                                    {dados.vinculo.datareabertura && dados.vinculo.feito !== 'sim' ?
                                        <span className="fin-pp__pill is-warn" title={"Atendimento reaberto em " + dataHora(dados.vinculo.datareabertura)}>
                                            Reaberto
                                        </span>
                                        : null}
                                    <label htmlFor="atendimentoConcluido" style={{ margin: 0, fontSize: 13, color: 'var(--fin-tx)', cursor: 'pointer' }}>
                                        Atendimento concluído
                                    </label>
                                    <div className="form-check form-switch mb-0">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            role="switch"
                                            id="atendimentoConcluido"
                                            style={{ width: '2.5em', height: '1.3em', cursor: 'pointer' }}
                                            title="Marque e salve para concluir o atendimento. Desmarque e salve para reabrir."
                                            checked={dados.atendimentoConcluido === true}
                                            onChange={(e) => {
                                                dados.atendimentoConcluido = e.target.checked;
                                                setDados({ ...dados });
                                            }}
                                        />
                                    </div>
                                </div>
                                : null}
                        </div>

                        {/* badges de datas de cartas */}
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 10 }}>
                            {dados.participante?.datacartaconvite &&
                                <span className="fin-pp__pill is-muted" title={"Carta convite enviada em: " + (dados.participante?.datacartaconvite ?? "") + ' ' + (dados.participante?.horacartaconvite ?? "")}>
                                    Carta convite enviada em: {(dados.participante?.datacartaconvite ?? "") + ' ' + (dados.participante?.horacartaconvite ?? "")}
                                </span>
                            }
                            {dados.participante?.datacartaassinada &&
                                <span className="fin-pp__pill is-ok" title={"Carta convite confirmada em: " + (dados.participante?.datacartaassinada ?? "") + ' ' + (dados.participante?.horacartaassinada ?? "")}>
                                    Carta convite confirmada em: {(dados.participante?.datacartaassinada ?? "") + ' ' + (dados.participante?.horacartaassinada ?? "")}
                                </span>
                            }
                            {dados.participante?.datacartainformativa &&
                                <span className="fin-pp__pill is-muted" title={"Carta informativa enviada em: " + (dados.participante?.datacartainformativa ?? "") + ' ' + (dados.participante?.horacartainformativa ?? "")}>
                                    Carta informativa enviada em: {(dados.participante?.datacartainformativa ?? "") + ' ' + (dados.participante?.horacartainformativa ?? "")}
                                </span>
                            }
                            {dados.participante?.dataconfirmacaocartainformativa &&
                                <span className="fin-pp__pill is-ok" title={"Carta informativa confirmada em: " + (dados.participante?.dataconfirmacaocartainformativa ?? "")}>
                                    Carta informativa confirmada em: {(dados.participante?.dataconfirmacaocartainformativa ?? "")}
                                </span>
                            }
                            {dados.participante?.datacertificado &&
                                <span className="fin-pp__pill is-muted" title={"Certificado enviado em: " + (dados.participante?.datacertificado ?? "") + ' ' + (dados.participante?.horacertificado ?? "")}>
                                    Certificado enviado em: {(dados.participante?.datacertificado ?? "") + ' ' + (dados.participante?.horacertificado ?? "")}
                                </span>
                            }
                        </div>

                        <div className="fin-pp__filters">
                            <FinField label="Nome Completo" required>
                                <FinInput id="nome" value={dados.participante?.nome ?? ""} style={{ paddingLeft: 14 }}
                                    onChange={(e) => { dados.participante.nome = e.target.value; setDados({ ...dados }); }} />
                            </FinField>
                            <FinField label="Nome para o Crachá">
                                <FinInput id="contato" value={dados.participante?.contato ?? ""} style={{ paddingLeft: 14 }}
                                    onChange={(e) => { dados.participante.contato = e.target.value; setDados({ ...dados }); }} />
                            </FinField>
                            <FinField label="E-mail">
                                <FinInput id="email" value={dados.participante?.email ?? ""} style={{ paddingLeft: 14 }}
                                    onChange={(e) => { dados.participante.email = e.target.value; setDados({ ...dados }); }} />
                            </FinField>
                            <FinField label="Outros E-mail's">
                                <FinInput id="emailsecundario" value={dados.participante?.emailsecundario ?? ""} style={{ paddingLeft: 14 }}
                                    onChange={(e) => { dados.participante.emailsecundario = e.target.value; setDados({ ...dados }); }} />
                            </FinField>
                            {!naoFarmaceutico ? (<>
                            <FinField label="CRM">
                                <div style={{ position: 'relative' }}>
                                    <FinInput
                                        id="crm"
                                        value={(verCrmOriginal ? dados.participante?.crmOriginal : dados.participante?.crm) ?? ""}
                                        style={{ paddingLeft: 14, paddingRight: dados.participante?.crmOriginal && dados.participante?.crm !== dados.participante?.crmOriginal ? 116 : 14 }}
                                        disabled={verCrmOriginal || dados.participante?.idioma === 'ingles' || !isTipoHcp(dados.participante?.tipoparticipante)}
                                        onChange={(e) => {
                                            const r = formatCrm(e.target.value, dados.participante?.crm, dados.participante?.crmuf);
                                            setDados({ ...dados, participante: { ...dados.participante, crm: r.crm, crmuf: r.crmuf, nomeUf: r.crmuf } });
                                        }}
                                    />
                                    {dados.participante?.crmOriginal && dados.participante?.crm !== dados.participante?.crmOriginal && (
                                        <span
                                            className="fin-pp__minitag is-warn"
                                            style={{ position: 'absolute', top: '50%', right: 10, transform: 'translateY(-50%)', cursor: 'pointer' }}
                                            title={verCrmOriginal ? 'Mostrando o CRM original da importação' : 'O convidado alterou o CRM; clique para ver o original'}
                                            onClick={() => setVerCrmOriginal((prev) => !prev)}
                                        >
                                            {verCrmOriginal ? 'Original' : 'Alterado'} {verCrmOriginal ? <FaEye size={11} /> : <FaEyeSlash size={11} />}
                                        </span>
                                    )}
                                </div>
                            </FinField>
                            <FinField label="Estado do CRM">
                                <ReactSelect
                                    id={"crmuf"}
                                    value={{ value: dados.participante?.crmuf ?? "", label: dados.participante?.crmuf }}
                                    isDisabled={verCrmOriginal || dados.participante?.idioma === 'ingles' || !isTipoHcp(dados.participante?.tipoparticipante)}
                                    onChange={(e) => {
                                        const crmuf = e ? e.value : '';
                                        const nomeUf = e ? e.label : '';
                                        const r = formatCrm((crmuf || '') + (dados.participante?.crm ?? '').replace(/\D/g, ''), dados.participante?.crm, crmuf);
                                        setDados({ ...dados, participante: { ...dados.participante, crmuf, nomeUf, crm: r.crm } });
                                    }}
                                    options={OPCOES_UF}
                                />
                            </FinField>
                            <div className="fin-pp__field">
                                {/* Não se aplica junto do label externo, no mesmo field para nunca se separar do campo */}
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
                                    <label className="fin-pp__label" htmlFor="conselho">Dados do Conselho</label>
                                    <FinCheck
                                        id="conselhoNaoAplicavel"
                                        label="Não se aplica"
                                        checked={!!dados.participante?.conselhoNaoAplicavel}
                                        disabled={dados.participante?.idioma === 'ingles' || isTipoHcp(dados.participante?.tipoparticipante)}
                                        onChange={(e) => {
                                            setDados({ ...dados, participante: { ...dados.participante, conselhoNaoAplicavel: e.target.checked, ...(e.target.checked ? { conselho: '', conselhouf: '' } : {}) } });
                                        }}
                                    />
                                </div>
                                <FinInput
                                    id="conselho"
                                    value={dados.participante?.conselho ?? ""}
                                    disabled={dados.participante?.idioma === 'ingles' || isTipoHcp(dados.participante?.tipoparticipante) || !!dados.participante?.conselhoNaoAplicavel}
                                    style={{ paddingLeft: 14 }}
                                    onChange={(e) => {
                                        setDados({ ...dados, participante: { ...dados.participante, conselho: e.target.value } });
                                    }}
                                />
                            </div>
                            <FinField label="Estado do Conselho" htmlFor="conselhouf">
                                <ReactSelect
                                    id={"conselhouf"}
                                    value={dados.participante?.conselhouf ? { value: dados.participante.conselhouf, label: dados.participante.conselhouf } : null}
                                    isDisabled={dados.participante?.idioma === 'ingles' || isTipoHcp(dados.participante?.tipoparticipante) || !!dados.participante?.conselhoNaoAplicavel}
                                    onChange={(e) => {
                                        setDados({ ...dados, participante: { ...dados.participante, conselhouf: e ? e.value : '' } });
                                    }}
                                    options={OPCOES_UF}
                                />
                            </FinField>
                            </>) : null}
                            <FinField label="RG">
                                <FinInput id="rg" value={dados.participante?.rg ?? ""} disabled={dados.participante?.idioma === 'ingles'} style={{ paddingLeft: 14 }}
                                    onChange={(e) => { dados.participante.rg = e.target.value; setDados({ ...dados }); }} />
                            </FinField>
                            <FinField label="CPF">
                                <InputMask mask="999.999.999-99" className="fin-pp__input" id="cpf"
                                    value={dados.participante?.cpf ?? ""}
                                    disabled={dados.participante?.idioma === 'ingles'}
                                    onChange={(e) => { dados.participante.cpf = e.target.value; setDados({ ...dados }); }}
                                    style={{ paddingLeft: 14 }}
                                />
                            </FinField>
                            <Data
                                id={"datanascimento"}
                                label="Data de Nascimento"
                                value={dados.participante?.datanascimento ?? null}
                                onChange={(date) => { dados.participante.datanascimento = date; setDados({ ...dados }); }}
                            />
                            <FinField label="Telefone">
                                <FinInput id="telefone" value={dados.participante?.telefone ?? ""} style={{ paddingLeft: 14 }}
                                    onChange={(e) => { dados.participante.telefone = e.target.value; setDados({ ...dados }); }} />
                            </FinField>
                            <FinField label="Telefone 2">
                                <FinInput id="telefone2" value={dados.participante?.telefone2 ?? ""} style={{ paddingLeft: 14 }}
                                    onChange={(e) => { dados.participante.telefone2 = e.target.value; setDados({ ...dados }); }} />
                            </FinField>
                            <FinField label="Celular">
                                <InputMask mask="(99) 99999-9999" className="fin-pp__input" id="celular"
                                    value={dados.participante?.celular ?? ""}
                                    onChange={(e) => { dados.participante.celular = e.target.value; setDados({ ...dados }); }}
                                    style={{ paddingLeft: 14 }}
                                />
                            </FinField>
                            <FinField label="Gerente Distrital">
                                <FinInput id="gerentedistrital" value={dados.participante?.gerentedistrital ?? ""} style={{ paddingLeft: 14 }}
                                    onChange={(e) => { dados.participante.gerentedistrital = e.target.value; setDados({ ...dados }); }} />
                            </FinField>
                            <FinField label="E-mail Gerente Distrital">
                                <FinInput id="gerentedistritalemail" value={dados.participante?.gerentedistritalemail ?? ""} style={{ paddingLeft: 14 }}
                                    onChange={(e) => { dados.participante.gerentedistritalemail = e.target.value; setDados({ ...dados }); }} />
                            </FinField>
                            <FinField label="Representante">
                                <FinInput id="representante" value={dados.participante?.representante ?? ""} style={{ paddingLeft: 14 }}
                                    onChange={(e) => { dados.participante.representante = e.target.value; setDados({ ...dados }); }} />
                            </FinField>
                            <FinField label="E-mail Representante">
                                <FinInput id="representanteemail" value={dados.participante?.representanteemail ?? ""} style={{ paddingLeft: 14 }}
                                    onChange={(e) => { dados.participante.representanteemail = e.target.value; setDados({ ...dados }); }} />
                            </FinField>
                            {!naoFarmaceutico ? (
                            <FinField label="Especialidade">
                                <FinInput id="especialidade" value={dados.participante?.especialidade ?? ""} style={{ paddingLeft: 14 }}
                                    onChange={(e) => { dados.participante.especialidade = e.target.value; setDados({ ...dados }); }} />
                            </FinField>
                            ) : null}
                            <FinField label="Instituição">
                                <FinInput id="instituicao" value={dados.participante?.instituicao ?? ""} style={{ paddingLeft: 14 }}
                                    onChange={(e) => { dados.participante.instituicao = e.target.value; setDados({ ...dados }); }} />
                            </FinField>
                            {naoFarmaceutico ? (<>
                            <FinField label="Cargo">
                                <ReactSelect
                                    id="cargoparticipante"
                                    value={dados.participante?.cargoparticipante ? { value: dados.participante.cargoparticipante, label: dados.participante.nomeCargoparticipante } : null}
                                    onChange={(e) => {
                                        setDados({
                                            ...dados,
                                            participante: {
                                                ...dados.participante,
                                                cargoparticipante: e ? e.value : '',
                                                nomeCargoparticipante: e ? e.label : '',
                                                // trocar de "Outros" para outro cargo limpa a especificação
                                                ...(e && String(e.value) === CARGO_OUTROS ? {} : { cargoespecificacao: '' })
                                            }
                                        });
                                    }}
                                    loadOptions={(input) => {
                                        return api({
                                            method: 'get',
                                            action: '/participanteCargo',
                                            token: token,
                                            params: { nome: input, categoria: CATEGORIA_NAO_FARMACEUTICO }
                                        })
                                            .then(response => {
                                                let options = response.data.data.map(registro => ({ value: registro.id, label: registro.nome }));
                                                return options;
                                            })
                                            .catch(function (error) {
                                                //console.log(error);
                                            });
                                    }}
                                />
                            </FinField>
                            {String(dados.participante?.cargoparticipante ?? '') === CARGO_OUTROS ? (
                                <FinField label="Especificação do Cargo">
                                    <FinInput id="cargoespecificacao" value={dados.participante?.cargoespecificacao ?? ""} style={{ paddingLeft: 14 }}
                                        onChange={(e) => { setDados({ ...dados, participante: { ...dados.participante, cargoespecificacao: e.target.value } }); }} />
                                </FinField>
                            ) : null}
                            </>) : null}
                            <FinField label="Tipo do Participante">
                                <ReactSelect
                                    id="tipoparticipante"
                                    // o AsyncSelect cacheia as opções da montagem, quando a categoria do
                                    // evento ainda não resolveu; a key remonta o select quando ela chega
                                    key={categoriaTipos ?? 'todos'}
                                    value={{ value: dados.participante?.tipoparticipante ?? "", label: dados.participante?.nomeTipoparticipante }}
                                    onChange={(e) => {
                                        dados.participante.tipoparticipante = e.value;
                                        dados.participante.nomeTipoparticipante = e.label;
                                        // HCP Virtual entra como online por padrão (editável)
                                        if (String(e.value) === '4') {
                                            dados.participante.tipoinscricao = 'online';
                                        }
                                        setDados({ ...dados });
                                    }}
                                    loadOptions={(input) => {
                                        return api({
                                            method: 'get',
                                            action: '/participanteTipo',
                                            token: token,
                                            // a categoria do evento define quais tipos existem para ele (o "Ambos", todos)
                                            params: { nome: input, categoria: categoriaTipos }
                                        })
                                            .then(response => {
                                                let options = response.data.data.map(registro => ({ value: registro.id, label: registro.nome }));
                                                return options;
                                            })
                                            .catch(function (error) {
                                                //console.log(error);
                                            });
                                    }}
                                />
                            </FinField>
                            <FinField label="Idioma">
                                <ReactSelect
                                    value={{ value: dados.participante?.idioma ?? "", label: dados.participante?.nomeIdioma }}
                                    onChange={(e) => {
                                        dados.participante.idioma = e.value;
                                        dados.participante.nomeIdioma = e.label;
                                        setDados({ ...dados });
                                    }}
                                    defaultOptions
                                    loadOptions={() => api({ method: 'get', action: '/idioma', token })
                                        .then(r => r.data.data.map(i => ({ value: i.codigo, label: i.nome })))
                                    }
                                />
                            </FinField>
                            <FinField label="ID">
                                <FinInput id="idconvidado" value={dados.participante?.idconvidado ?? ""} style={{ paddingLeft: 14 }}
                                    onChange={(e) => { dados.participante.idconvidado = e.target.value; setDados({ ...dados }); }} />
                            </FinField>
                            <FinField label="Sócio">
                                <FinInput id="socio" value={dados.participante?.socio ?? ""} style={{ paddingLeft: 14 }}
                                    onChange={(e) => { dados.participante.socio = e.target.value; setDados({ ...dados }); }} />
                            </FinField>
                        </div>

                        {/* ── Datas de cartas / controle ── */}
                        <div className="fin-pp__filters" style={{ marginTop: 12 }}>
                            <Data
                                readOnly={true} id={"datacartaconvite"}
                                label="Data Carta Convite"
                                value={dados.participante?.datacartaconvite ?? null}
                                onChange={(date) => { dados.participante.datacartaconvite = date; setDados({ ...dados }); }}
                            />
                            <FinField label="Hora Carta Convite">
                                <InputMask mask="99:99" readOnly className="fin-pp__input campoHora" id="horacartaconvite"
                                    value={dados.participante?.horacartaconvite ?? ""}
                                    onChange={(e) => { dados.participante.horacartaconvite = e.target.value; setDados({ ...dados }); }}
                                    style={{ paddingLeft: 14 }}
                                />
                            </FinField>
                            <Data
                                readOnly={true} id={"datacartaassinada"}
                                label="Data Aceite Convite"
                                value={dados.participante?.datacartaassinada ?? null}
                                onChange={(date) => { dados.participante.datacartaassinada = date; setDados({ ...dados }); }}
                            />
                            <FinField label="Hora Aceite Convite">
                                <InputMask mask="99:99" readOnly className="fin-pp__input campoHora" id="horacartaassinada"
                                    value={dados.participante?.horacartaassinada ?? ""}
                                    onChange={(e) => { dados.participante.horacartaassinada = e.target.value; setDados({ ...dados }); }}
                                    style={{ paddingLeft: 14 }}
                                />
                            </FinField>
                            <Data
                                readOnly={true} id={"dataopcaoaereo"}
                                label="Data Opção de Aéreo"
                                value={dados.participante?.dataopcaoaereo ?? null}
                                onChange={(date) => { dados.participante.dataopcaoaereo = date; setDados({ ...dados }); }}
                            />
                            <Data
                                readOnly={true} id={"dataconfirmacaodados"}
                                label="Data Confirmação Dados"
                                value={dados.participante?.dataconfirmacaodados ?? null}
                                onChange={(date) => { dados.participante.dataconfirmacaodados = date; setDados({ ...dados }); }}
                            />
                            <Data
                                readOnly={true} id={"dataescolhaaereo"}
                                label="Data Escolha Aéreo"
                                value={dados.participante?.dataescolhaaereo ?? null}
                                onChange={(date) => { dados.participante.dataescolhaaereo = date; setDados({ ...dados }); }}
                            />
                            <FinField label="Hora Escolha Aéreo">
                                <InputMask mask="99:99" readOnly className="fin-pp__input campoHora" id="horaescolhaaereo"
                                    value={dados.participante?.horaescolhaaereo ?? null}
                                    onChange={(e) => { dados.participante.horaescolhaaereo = e.target.value; setDados({ ...dados }); }}
                                    style={{ paddingLeft: 14 }}
                                />
                            </FinField>
                            <Data
                                id={"datainscricao"}
                                label="Data Inscrição"
                                value={dados.participante?.datainscricao ?? null}
                                onChange={(date) => { dados.participante.datainscricao = date; setDados({ ...dados }); }}
                            />
                            <Data
                                id={"datacartainformativa"}
                                label="Data Carta Informativa"
                                value={dados.participante?.datacartainformativa ?? null}
                                onChange={(date) => { dados.participante.datacartainformativa = date; setDados({ ...dados }); }}
                            />
                            <FinField label="Hora Carta Informativa">
                                <InputMask mask="99:99" className="fin-pp__input campoHora" id="horacartainformativa"
                                    value={dados.participante?.horacartainformativa ?? ""}
                                    onChange={(e) => { dados.participante.horacartainformativa = e.target.value; setDados({ ...dados }); }}
                                    style={{ paddingLeft: 14 }}
                                />
                            </FinField>
                            <Data
                                id={"dataconfirmacaocartainformativa"}
                                label="Data Confirmação Informativa"
                                value={dados.participante?.dataconfirmacaocartainformativa ?? null}
                                onChange={(date) => { dados.participante.dataconfirmacaocartainformativa = date; setDados({ ...dados }); }}
                            />
                            <Data
                                id={"datacertificado"}
                                label="Data Certificado"
                                value={dados.participante?.datacertificado ?? null}
                                onChange={(date) => { dados.participante.datacertificado = date; setDados({ ...dados }); }}
                            />
                            <FinField label="Hora Certificado">
                                <InputMask mask="99:99" className="fin-pp__input campoHora" id="horacertificado"
                                    value={dados.participante?.horacertificado ?? ""}
                                    onChange={(e) => { dados.participante.horacertificado = e.target.value; setDados({ ...dados }); }}
                                    style={{ paddingLeft: 14 }}
                                />
                            </FinField>
                        </div>
                    </div>

                    {/* ── ENDEREÇO ── */}
                    <div className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 16 }}>
                        <div className="fin-pp__cphead">
                            <span className="fin-pp__cphead-title">Dados de Endereço</span>
                        </div>
                        <div className="fin-pp__filters">
                            <FinField label="Rua / Logradouro" full>
                                <FinInput id="enderecologradouro" value={dados.participante?.enderecologradouro ?? ""} style={{ paddingLeft: 14 }}
                                    onChange={(e) => { dados.participante.enderecologradouro = e.target.value; setDados({ ...dados }); }} />
                            </FinField>
                            <FinField label="Número">
                                <FinInput id="endereconumero" value={dados.participante?.endereconumero ?? ""} style={{ paddingLeft: 14 }}
                                    onChange={(e) => { dados.participante.endereconumero = e.target.value; setDados({ ...dados }); }} />
                            </FinField>
                            <FinField label="Complemento" full>
                                <FinInput id="enderecocomplemento" value={dados.participante?.enderecocomplemento ?? ""} style={{ paddingLeft: 14 }}
                                    onChange={(e) => { dados.participante.enderecocomplemento = e.target.value; setDados({ ...dados }); }} />
                            </FinField>
                            <FinField label="CEP">
                                <FinInput id="enderecocep" value={dados.participante?.enderecocep ?? ""} style={{ paddingLeft: 14 }}
                                    onChange={(e) => {
                                        dados.participante.enderecocep = e.target.value;
                                        preencherCep(e.target.value, dados);
                                        setDados({ ...dados });
                                    }} />
                            </FinField>
                            <FinField label="Bairro">
                                <FinInput id="enderecobairro" value={dados.participante?.enderecobairro ?? ""} style={{ paddingLeft: 14 }}
                                    onChange={(e) => { dados.participante.enderecobairro = e.target.value; setDados({ ...dados }); }} />
                            </FinField>
                            <FinField label="Estado">
                                <ReactSelect
                                    id={"enderecouf"}
                                    value={{ value: dados.participante?.enderecouf ?? "", label: dados.participante?.enderecouf }}
                                    isDisabled={dados.participante?.idioma === 'ingles'}
                                    onChange={(e) => { dados.participante.enderecouf = e.value; setDados({ ...dados }); }}
                                    options={OPCOES_UF}
                                />
                            </FinField>
                            <FinField label="Cidade">
                                <ReactSelect
                                    value={{ value: dados.participante?.enderecomunicipio ?? "", label: dados.participante?.nomeEnderecomunicipio }}
                                    isDisabled={dados.participante?.idioma === 'ingles'}
                                    onChange={(e) => {
                                        dados.participante.enderecomunicipio = e.value;
                                        dados.participante.nomeEnderecomunicipio = e.label;
                                        setDados({ ...dados });
                                    }}
                                    loadOptions={(input) => {
                                        return api({
                                            method: 'get',
                                            action: '/municipio',
                                            token: token,
                                            params: { nome: input, uf: dados.participante?.enderecouf ?? null }
                                        })
                                            .then(response => {
                                                let options = response.data.data.map(registro => ({ value: registro.id, label: registro.nome + "-" + registro.uf }));
                                                return options;
                                            })
                                            .catch(function (error) {
                                                //console.log(error);
                                            });
                                    }}
                                />
                            </FinField>
                            <FinField label="País">
                                <ReactSelect
                                    value={{ value: dados.participante?.enderecopais ?? "", label: dados.participante?.nomeEnderecopais }}
                                    onChange={(e) => {
                                        dados.participante.enderecopais = e.value;
                                        dados.participante.nomeEnderecopais = e.label;
                                        setDados({ ...dados });
                                    }}
                                    loadOptions={(input) => {
                                        return api({
                                            method: 'get',
                                            action: '/pais',
                                            token: token,
                                            params: { nome: input }
                                        })
                                            .then(response => {
                                                let options = response.data.data.map(registro => ({ value: registro.id, label: registro.nome }));
                                                return options;
                                            })
                                            .catch(function (error) {
                                                //console.log(error);
                                            });
                                    }}
                                />
                            </FinField>
                            <FinField label="Aeroporto de Origem">
                                <FinInput id="aeroportoOrigem" value={dados.participante?.aeroportoOrigem} style={{ paddingLeft: 14 }}
                                    onChange={(e) => { dados.participante.aeroportoOrigem = e.target.value; setDados({ ...dados }); }} />
                            </FinField>
                            <FinField label="Cidade de Embarque">
                                <ReactSelect
                                    value={{ value: dados.participante?.aereomunicipioembarque ?? "", label: dados.participante?.nomeAereomunicipioembarque }}
                                    onChange={(e) => {
                                        dados.participante.aereomunicipioembarque = e.value;
                                        dados.participante.nomeAereomunicipioembarque = e.label;
                                        setDados({ ...dados });
                                    }}
                                    loadOptions={(input) => {
                                        return api({
                                            method: 'get',
                                            action: '/municipio',
                                            token: token,
                                            params: { nome: input, uf: dados.participante?.enderecouf ?? null }
                                        })
                                            .then(response => {
                                                let options = response.data.data.map(registro => ({ value: registro.id, label: registro.nome + "-" + registro.uf }));
                                                return options;
                                            })
                                            .catch(function (error) {
                                                //console.log(error);
                                            });
                                    }}
                                />
                            </FinField>
                        </div>
                    </div>

                    {/* ── TABS ── */}
                    <div className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 16 }}>
                        <ul className="nav nav-tabs mb-3">
                            <li className="nav-item">
                                <button type="button" className={`nav-link ${tab === 'colunasnomeaveis' ? 'active' : ''}`} onClick={() => setTab('colunasnomeaveis')}>
                                    <FaColumns size={13} style={{ marginRight: 4 }} />Colunas Nomeáveis
                                </button>
                            </li>
                            <li className="nav-item">
                                <button type="button" className={`nav-link ${tab === 'hotel' ? 'active' : ''}`} onClick={() => setTab('hotel')}>
                                    <input type="checkbox" readOnly checked={dados.participante?.hotelhospedagem === 'sim'} style={{ marginRight: 4 }} />Hospedagem
                                </button>
                            </li>
                            <li className="nav-item">
                                <button type="button" className={`nav-link ${tab === 'aereo' ? 'active' : ''}`} onClick={() => setTab('aereo')}>
                                    <input type="checkbox" readOnly checked={dados.participante?.aereo === 'sim'} style={{ marginRight: 4 }} />Aéreo
                                </button>
                            </li>
                            <li className="nav-item">
                                <button type="button" className={`nav-link ${tab === 'inscricao' ? 'active' : ''}`} onClick={() => setTab('inscricao')}>
                                    <input type="checkbox" readOnly checked={dados.participante?.inscricao === 'sim'} style={{ marginRight: 4 }} />Inscrição
                                </button>
                            </li>
                            <li className="nav-item">
                                <button type="button" className={`nav-link ${tab === 'transfer' ? 'active' : ''}`} onClick={() => setTab('transfer')}>
                                    <input type="checkbox" readOnly checked={dados.participante?.transfer === 'sim' || dados.participante?.transferextra === 'sim'} style={{ marginRight: 4 }} />Transfer
                                </button>
                            </li>
                            <li className="nav-item">
                                <button type="button" className={`nav-link ${tab === 'observacao' ? 'active' : ''}`} onClick={() => setTab('observacao')}>
                                    <FaStickyNote size={13} style={{ marginRight: 4 }} />Observações Importantes
                                </button>
                            </li>
                        </ul>

                        {/* ── Aba: Colunas Nomeáveis ── */}
                        {tab === 'colunasnomeaveis' && (
                            <div className="fin-pp__filters">
                                {/* Colunas vêm normalizadas do back (`participante.colunas`): uma por coluna
                                    do evento, com nome, ordem (que é a posição) e ativo. Não há mais 1..10
                                    fixo — a 11ª em diante aparece aqui sozinha. Coluna travada no cadeado
                                    (ativo=false) é exibida somente leitura, nunca escondida de quem opera. */}
                                {(dados.participante?.colunas ?? []).map(coluna => (
                                    <FinField key={coluna.id} label={coluna.nome}>
                                        <FinInput id={'coluna' + coluna.ordem}
                                            value={coluna.valor ?? ""}
                                            disabled={!coluna.ativo}
                                            style={{ paddingLeft: 14 }}
                                            onChange={(e) => {
                                                const valor = e.target.value;
                                                setDados({
                                                    ...dados,
                                                    participante: {
                                                        ...dados.participante,
                                                        colunas: dados.participante.colunas.map(atual => (
                                                            atual.id === coluna.id ? { ...atual, valor } : atual
                                                        )),
                                                    },
                                                });
                                            }}
                                        />
                                    </FinField>
                                ))}
                                {(dados.participante?.colunas ?? []).length === 0 && (
                                    <span className="fin-pp__cell-muted">Este evento não tem colunas nomeáveis.</span>
                                )}
                            </div>
                        )}

                        {/* ── Aba: Hospedagem ── */}
                        {tab === 'hotel' && (
                            <div>
                                <div className="fin-pp__filters">
                                    <FinField label="Possui Hospedagem?">
                                        <ReactSelect
                                            value={{ value: dados.participante?.hotelhospedagem ?? "", label: dados.participante?.nomeHotelhospedagem }}
                                            onChange={(e) => {
                                                dados.participante.hotelhospedagem = e.value;
                                                dados.participante.nomeHotelhospedagem = e.label;
                                                setDados({ ...dados });
                                            }}
                                            options={OPCOES_HOSPEDAGEM}
                                        />
                                    </FinField>
                                    <FinField label="Hotel">
                                        <FinInput id="hotelnome" value={dados.participante?.hotelnome ?? ""} style={{ paddingLeft: 14 }}
                                            onChange={(e) => { dados.participante.hotelnome = e.target.value; setDados({ ...dados }); }} />
                                    </FinField>
                                    <FinField label="Tipo de Quarto">
                                        <FinInput id="hoteltipoquarto" value={dados.participante?.hoteltipoquarto ?? ""} style={{ paddingLeft: 14 }}
                                            onChange={(e) => { dados.participante.hoteltipoquarto = e.target.value; setDados({ ...dados }); }} />
                                    </FinField>
                                    <Data
                                        id={"hoteldatacheckin"}
                                        label="Data do checkin"
                                        value={dados.participante?.hoteldatacheckin ?? null}
                                        onChange={(date) => { dados.participante.hoteldatacheckin = date; setDados({ ...dados }); }}
                                    />
                                    <FinField label="Hora do checkin">
                                        <InputMask mask="99:99" className="fin-pp__input" id="hotelhoracheckin"
                                            value={dados.participante?.hotelhoracheckin ?? ""}
                                            onChange={(e) => { dados.participante.hotelhoracheckin = e.target.value; setDados({ ...dados }); }}
                                            style={{ paddingLeft: 14 }}
                                        />
                                    </FinField>
                                    <Data
                                        id={"hoteldatacheckout"}
                                        label="Data do checkout"
                                        value={dados.participante?.hoteldatacheckout ?? null}
                                        onChange={(date) => { dados.participante.hoteldatacheckout = date; setDados({ ...dados }); }}
                                    />
                                    <FinField label="Hora do checkout">
                                        <InputMask mask="99:99" className="fin-pp__input" id="hotelhoracheckout"
                                            value={dados.participante?.hotelhoracheckout ?? ""}
                                            onChange={(e) => { dados.participante.hotelhoracheckout = e.target.value; setDados({ ...dados }); }}
                                            style={{ paddingLeft: 14 }}
                                        />
                                    </FinField>
                                    <FinField label="Observação" full>
                                        <FinTextarea id="hotelobservacao"
                                            value={dados.participante?.hotelobservacao ?? ""}
                                            onChange={(e) => { dados.participante.hotelobservacao = e.target.value; setDados({ ...dados }); }}
                                        />
                                    </FinField>
                                </div>
                            </div>
                        )}

                        {/* ── Aba: Aéreo ── */}
                        {tab === 'aereo' && (
                            <div>
                                <div className="fin-pp__filters">
                                    <FinField label="Possui Aéreo?">
                                        <ReactSelect
                                            value={{ value: dados.participante?.aereo ?? "", label: dados.participante?.nomeAereo }}
                                            onChange={(e) => {
                                                dados.participante.aereo = e.value;
                                                dados.participante.nomeAereo = e.label;
                                                setDados({ ...dados });
                                            }}
                                            options={OPCOES_AEREO}
                                        />
                                    </FinField>
                                </div>

                                {/* Ida */}
                                <div className="fin-pp__cphead" style={{ marginTop: 12 }}>
                                    <span className="fin-pp__cphead-ic"><FaPlaneDeparture size={15} /></span>
                                    <span className="fin-pp__cphead-title">Dados Ida</span>
                                    {idaCompleta(idaSalva) && <span className="fin-pp__pill is-ok" style={{ marginLeft: 8 }}>Já Selecionado Pelo Participante</span>}
                                    {/* sem a pílula os campos ficam vazios e parece que a escolha não foi registrada */}
                                    {!!dados.participante?.naoutilizaraereoida && <span className="fin-pp__pill is-warn" style={{ marginLeft: 8 }}>Participante não utilizará este trecho</span>}
                                </div>
                                <div className="fin-pp__filters">
                                    <FinField label="Data">
                                        <FinInput id="aereoidadata" value={dados.participante?.aereoidadata ?? ""} style={{ paddingLeft: 14 }}
                                            onChange={(e) => { dados.participante.aereoidadata = e.target.value; setDados({ ...dados }); }} />
                                    </FinField>
                                    <FinField label="Origem">
                                        <FinInput id="aereoidaorigem" value={dados.participante?.aereoidaorigem ?? ""} style={{ paddingLeft: 14 }}
                                            onChange={(e) => { dados.participante.aereoidaorigem = e.target.value; setDados({ ...dados }); }} />
                                    </FinField>
                                    <FinField label="Companhia Aérea">
                                        <FinInput id="aereoidacompanhia" value={dados.participante?.aereoidacompanhia ?? ""} style={{ paddingLeft: 14 }}
                                            onChange={(e) => { dados.participante.aereoidacompanhia = e.target.value; setDados({ ...dados }); }} />
                                    </FinField>
                                    <FinField label="Voo">
                                        <FinInput id="aereoidavoo" value={dados.participante?.aereoidavoo ?? ""} style={{ paddingLeft: 14 }}
                                            onChange={(e) => { dados.participante.aereoidavoo = e.target.value; setDados({ ...dados }); }} />
                                    </FinField>
                                    <FinField label="Hora Saída">
                                        <FinInput id="aereoidahorasaida" value={dados.participante?.aereoidahorasaida ?? ""} style={{ paddingLeft: 14 }}
                                            onChange={(e) => { dados.participante.aereoidahorasaida = e.target.value; setDados({ ...dados }); }} />
                                    </FinField>
                                    <FinField label="Hora Chegada">
                                        <FinInput id="aereoidahorachegada" value={dados.participante?.aereoidahorachegada ?? ""} style={{ paddingLeft: 14 }}
                                            onChange={(e) => { dados.participante.aereoidahorachegada = e.target.value; setDados({ ...dados }); }} />
                                    </FinField>
                                    <FinField label="Destino">
                                        <FinInput id="aereoidadestino" value={dados.participante?.aereoidadestino ?? ""} style={{ paddingLeft: 14 }}
                                            onChange={(e) => { dados.participante.aereoidadestino = e.target.value; setDados({ ...dados }); }} />
                                    </FinField>
                                    <FinField label="Localizador">
                                        <FinInput id="aereoidalocalizador" value={dados.participante?.aereoidalocalizador ?? ""} style={{ paddingLeft: 14 }}
                                            onChange={(e) => { dados.participante.aereoidalocalizador = e.target.value; setDados({ ...dados }); }} />
                                    </FinField>
                                    <FinField label="E-ticket">
                                        <FinInput id="aereoidaeticket" value={dados.participante?.aereoidaeticket ?? ""} style={{ paddingLeft: 14 }}
                                            onChange={(e) => { dados.participante.aereoidaeticket = e.target.value; setDados({ ...dados }); }} />
                                    </FinField>
                                    <FinField label="Conexão">
                                        <FinInput id="aereoidaconexao" value={dados.participante?.aereoidaconexao ?? ""} style={{ paddingLeft: 14 }}
                                            onChange={(e) => { dados.participante.aereoidaconexao = e.target.value; setDados({ ...dados }); }} />
                                    </FinField>
                                    <FinField label="Trecho de ida">
                                        <label className="d-flex align-items-center" style={{ marginBottom: 0, minHeight: 46 }}>
                                            <input
                                                type="checkbox"
                                                id="naoutilizaraereoida"
                                                checked={!!dados.participante?.naoutilizaraereoida}
                                                onChange={(e) => { dados.participante.naoutilizaraereoida = e.target.checked; setDados({ ...dados }); }}
                                                style={{ marginRight: 8 }}
                                            />
                                            Não utilizará este trecho
                                        </label>
                                    </FinField>
                                    <FinField label="Observação Ida" full>
                                        <FinTextarea id="aereoidaobservacao"
                                            value={dados.participante?.aereoidaobservacao ?? ""}
                                            onChange={(e) => { dados.participante.aereoidaobservacao = e.target.value; setDados({ ...dados }); }}
                                        />
                                    </FinField>
                                </div>

                                {/* Retorno */}
                                <div className="fin-pp__cphead" style={{ marginTop: 12 }}>
                                    <span className="fin-pp__cphead-ic"><FaPlaneArrival size={15} /></span>
                                    <span className="fin-pp__cphead-title">Dados Retorno</span>
                                    {retornoCompleto(retornoSalva) && <span className="fin-pp__pill is-ok" style={{ marginLeft: 8 }}>Já Selecionado Pelo Participante</span>}
                                    {/* sem a pílula os campos ficam vazios e parece que a escolha não foi registrada */}
                                    {!!dados.participante?.naoutilizaraereoretorno && <span className="fin-pp__pill is-warn" style={{ marginLeft: 8 }}>Participante não utilizará este trecho</span>}
                                </div>
                                <div className="fin-pp__filters">
                                    <FinField label="Data">
                                        <FinInput id="aereoretornodata" value={dados.participante?.aereoretornodata ?? ""} style={{ paddingLeft: 14 }}
                                            onChange={(e) => { dados.participante.aereoretornodata = e.target.value; setDados({ ...dados }); }} />
                                    </FinField>
                                    <FinField label="Origem">
                                        <FinInput id="aereoretornoorigem" value={dados.participante?.aereoretornoorigem ?? ""} style={{ paddingLeft: 14 }}
                                            onChange={(e) => { dados.participante.aereoretornoorigem = e.target.value; setDados({ ...dados }); }} />
                                    </FinField>
                                    <FinField label="Companhia Aérea">
                                        <FinInput id="aereoretornocompanhia" value={dados.participante?.aereoretornocompanhia ?? ""} style={{ paddingLeft: 14 }}
                                            onChange={(e) => { dados.participante.aereoretornocompanhia = e.target.value; setDados({ ...dados }); }} />
                                    </FinField>
                                    <FinField label="Voo">
                                        <FinInput id="aereoretornovoo" value={dados.participante?.aereoretornovoo ?? ""} style={{ paddingLeft: 14 }}
                                            onChange={(e) => { dados.participante.aereoretornovoo = e.target.value; setDados({ ...dados }); }} />
                                    </FinField>
                                    <FinField label="Hora Saída">
                                        <FinInput id="aereoretornohorasaida" value={dados.participante?.aereoretornohorasaida ?? ""} style={{ paddingLeft: 14 }}
                                            onChange={(e) => { dados.participante.aereoretornohorasaida = e.target.value; setDados({ ...dados }); }} />
                                    </FinField>
                                    <FinField label="Hora Chegada">
                                        <FinInput id="aereoretornohorachegada" value={dados.participante?.aereoretornohorachegada ?? ""} style={{ paddingLeft: 14 }}
                                            onChange={(e) => { dados.participante.aereoretornohorachegada = e.target.value; setDados({ ...dados }); }} />
                                    </FinField>
                                    <FinField label="Destino">
                                        <FinInput id="aereoretornodestino" value={dados.participante?.aereoretornodestino ?? ""} style={{ paddingLeft: 14 }}
                                            onChange={(e) => { dados.participante.aereoretornodestino = e.target.value; setDados({ ...dados }); }} />
                                    </FinField>
                                    <FinField label="Localizador">
                                        <FinInput id="aereoretornolocalizador" value={dados.participante?.aereoretornolocalizador ?? ""} style={{ paddingLeft: 14 }}
                                            onChange={(e) => { dados.participante.aereoretornolocalizador = e.target.value; setDados({ ...dados }); }} />
                                    </FinField>
                                    <FinField label="E-ticket">
                                        <FinInput id="aereoretornoeticket" value={dados.participante?.aereoretornoeticket ?? ""} style={{ paddingLeft: 14 }}
                                            onChange={(e) => { dados.participante.aereoretornoeticket = e.target.value; setDados({ ...dados }); }} />
                                    </FinField>
                                    <FinField label="Conexão">
                                        <FinInput id="aereoretornoconexao" value={dados.participante?.aereoretornoconexao ?? ""} style={{ paddingLeft: 14 }}
                                            onChange={(e) => { dados.participante.aereoretornoconexao = e.target.value; setDados({ ...dados }); }} />
                                    </FinField>
                                    <FinField label="Trecho de retorno">
                                        <label className="d-flex align-items-center" style={{ marginBottom: 0, minHeight: 46 }}>
                                            <input
                                                type="checkbox"
                                                id="naoutilizaraereoretorno"
                                                checked={!!dados.participante?.naoutilizaraereoretorno}
                                                onChange={(e) => { dados.participante.naoutilizaraereoretorno = e.target.checked; setDados({ ...dados }); }}
                                                style={{ marginRight: 8 }}
                                            />
                                            Não utilizará este trecho
                                        </label>
                                    </FinField>
                                    <FinField label="Observação Retorno" full>
                                        <FinTextarea id="aereoretornoobservacao"
                                            value={dados.participante?.aereoretornoobservacao ?? ""}
                                            onChange={(e) => { dados.participante.aereoretornoobservacao = e.target.value; setDados({ ...dados }); }}
                                        />
                                    </FinField>
                                </div>

                                <div className="fin-pp__filters">
                                    <FinField label="Documentos necessários para entrada no país (se preenchido, sobrepõe o texto padrão do evento)" full>
                                        <FinTextarea id="documentosentradapais"
                                            value={dados.participante?.documentosentradapais ?? ""}
                                            onChange={(e) => { dados.participante.documentosentradapais = e.target.value; setDados({ ...dados }); }}
                                        />
                                    </FinField>
                                </div>

                                {/* Declaração escrita do convidado sobre o que ele tem/o que falta (tela de
                                    escolha de aéreo). Editável aqui porque o RSVP complementa e corrige o que
                                    foi declarado antes de repassar ao laboratório — é o mesmo campo que sai no
                                    relatório de participantes e na planilha de emissão de aéreo. */}
                                <div className="fin-pp__filters">
                                    <FinField label="Pendência de documentos para entrada no país (declarada pelo convidado)" full>
                                        <FinTextarea id="pendenciadocumentosentradapais"
                                            value={dados.participante?.pendenciadocumentosentradapais ?? ""}
                                            onChange={(e) => { dados.participante.pendenciadocumentosentradapais = e.target.value; setDados({ ...dados }); }}
                                        />
                                    </FinField>
                                </div>

                                {/* Carimbo do "Estou ciente..." marcado pelo convidado na tela de escolha de aéreo.
                                    Só leitura: o setter é o escolhaAereo, e o Salvar desta tela não altera o campo. */}
                                {dados.participante?.datacientedocumentosentradapais &&
                                    <div style={{ marginTop: 8 }}>
                                        <span className="fin-pp__pill is-ok" title={"O convidado declarou ciência dos documentos de entrada no país em: " + dataHora(dados.participante.datacientedocumentosentradapais)}>
                                            Ciência dos documentos declarada em: {dataHora(dados.participante.datacientedocumentosentradapais)}
                                        </span>
                                    </div>
                                }

                                {/* Opções disponíveis — Ida */}
                                <div className="fin-pp__cphead" style={{ marginTop: 16 }}>
                                    <span className="fin-pp__cphead-title">Opções de aéreo disponíveis</span>
                                </div>
                                <div className="fin-pp__card" style={{ overflow: 'hidden', marginBottom: 12 }}>
                                    <div style={{ padding: '6px 12px', fontWeight: 600, fontSize: 13 }}>
                                        <FaPlaneDeparture size={14} style={{ marginRight: 6 }} />Ida
                                    </div>
                                    <div className="fin-pp__tblwrap">
                                        <table className="fin-pp__tbl fin-pp__tbl--aereo">
                                            <thead>
                                                <tr>
                                                    <th>Data</th><th>Cia</th><th>Voo</th><th>Origem</th>
                                                    <th>Destino</th><th>Saída</th><th>Chegada</th><th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {dados.participante?.evento?.eventoaereo
                                                    ? dados.participante.evento.eventoaereo.filter(idaTemDados).map((row, rowIndex) => (
                                                        <tr key={rowIndex} style={idaCompleta(idaSalva) && !compareIda(idaSalva, row) ? { opacity: 0.4 } : {}}>
                                                            <td>{(row.idadata ?? '').split("|").map((valor, vi) => <React.Fragment key={vi}>{valor}<br /></React.Fragment>)}</td>
                                                            <td>{(row.idacompanhia ?? '').split("|").map((valor, vi) => <React.Fragment key={vi}>{valor}<br /></React.Fragment>)}</td>
                                                            <td>{(row.idavoo ?? '').split("|").map((valor, vi) => <React.Fragment key={vi}>{valor}<br /></React.Fragment>)}</td>
                                                            <td><LocalAereo valor={row.idaorigem} /></td>
                                                            <td><LocalAereo valor={row.idadestino} /></td>
                                                            <td>{(row.idahorasaida ?? '').split("|").map((valor, vi) => <React.Fragment key={vi}>{valor}<br /></React.Fragment>)}</td>
                                                            <td>{(row.idahorachegada ?? '').split("|").map((valor, vi) => <React.Fragment key={vi}>{valor}<br /></React.Fragment>)}</td>
                                                            <td>{compareIda(idaSalva, row) && <span className="fin-pp__pill is-ok">Selecionado</span>}</td>
                                                        </tr>
                                                    ))
                                                    : null
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                {/* Opções disponíveis — Volta */}
                                <div className="fin-pp__card" style={{ overflow: 'hidden', marginBottom: 12 }}>
                                    <div style={{ padding: '6px 12px', fontWeight: 600, fontSize: 13 }}>
                                        <FaPlaneArrival size={14} style={{ marginRight: 6 }} />Volta
                                    </div>
                                    <div className="fin-pp__tblwrap">
                                        <table className="fin-pp__tbl fin-pp__tbl--aereo">
                                            <thead>
                                                <tr>
                                                    <th>Data</th><th>Cia</th><th>Voo</th><th>Origem</th>
                                                    <th>Destino</th><th>Saída</th><th>Chegada</th><th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {dados.participante?.evento?.eventoaereo
                                                    ? dados.participante.evento.eventoaereo.filter(retornoTemDados).map((row, rowIndex) => (
                                                        <tr key={rowIndex} style={retornoCompleto(retornoSalva) && !compareRetorno(retornoSalva, row) ? { opacity: 0.4 } : {}}>
                                                            <td>{(row.retornodata ?? '').split("|").map((valor, vi) => <React.Fragment key={vi}>{valor}<br /></React.Fragment>)}</td>
                                                            <td>{(row.retornocompanhia ?? '').split("|").map((valor, vi) => <React.Fragment key={vi}>{valor}<br /></React.Fragment>)}</td>
                                                            <td>{(row.retornovoo ?? '').split("|").map((valor, vi) => <React.Fragment key={vi}>{valor}<br /></React.Fragment>)}</td>
                                                            <td><LocalAereo valor={row.retornoorigem} /></td>
                                                            <td><LocalAereo valor={row.retornodestino} /></td>
                                                            <td>{(row.retornohorasaida ?? '').split("|").map((valor, vi) => <React.Fragment key={vi}>{valor}<br /></React.Fragment>)}</td>
                                                            <td>{(row.retornohorachegada ?? '').split("|").map((valor, vi) => <React.Fragment key={vi}>{valor}<br /></React.Fragment>)}</td>
                                                            <td>{compareRetorno(retornoSalva, row) && <span className="fin-pp__pill is-ok">Selecionado</span>}</td>
                                                        </tr>
                                                    ))
                                                    : null
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* ── Aba: Inscrição ── */}
                        {tab === 'inscricao' && (
                            <div className="fin-pp__filters">
                                <FinField label="Possui Inscrição?">
                                    <ReactSelect
                                        value={{ value: dados.participante?.inscricao ?? "", label: dados.participante?.nomeInscricao }}
                                        onChange={(e) => {
                                            dados.participante.inscricao = e.value;
                                            dados.participante.nomeInscricao = e.label;
                                            setDados({ ...dados });
                                        }}
                                        options={OPCOES_INSCRICAO}
                                    />
                                </FinField>
                                <FinField label="Número de Inscrição">
                                    <FinInput id="inscricaonumero" value={dados.participante?.inscricaonumero ?? ""} style={{ paddingLeft: 14 }}
                                        onChange={(e) => { dados.participante.inscricaonumero = e.target.value; setDados({ ...dados }); }} />
                                </FinField>
                                <FinField label="Tipo de Inscrição">
                                    <div title={dados.participante?.evento?.tipoRealizacao === 'hibrido' ? undefined : 'Habilitado somente para eventos híbridos'}>
                                        <ReactSelect
                                            isDisabled={dados.participante?.evento?.tipoRealizacao !== 'hibrido'}
                                            value={dados.participante?.tipoinscricao ? { value: dados.participante.tipoinscricao, label: dados.participante.tipoinscricao === 'online' ? 'Online' : 'Presencial' } : null}
                                            onChange={(e) => {
                                                dados.participante.tipoinscricao = e ? e.value : '';
                                                setDados({ ...dados });
                                            }}
                                            options={[
                                                { value: 'online', label: 'Online' },
                                                { value: 'presencial', label: 'Presencial' },
                                            ]}
                                        />
                                    </div>
                                </FinField>
                            </div>
                        )}

                        {/* ── Aba: Transfer ── */}
                        {tab === 'transfer' && (
                            <div>
                                <div className="fin-pp__filters">
                                    <FinField label="Possui Transfer?">
                                        <ReactSelect
                                            value={{ value: dados.participante?.transfer ?? "", label: dados.participante?.nomeTransfer }}
                                            onChange={(e) => {
                                                dados.participante.transfer = e.value;
                                                dados.participante.nomeTransfer = e.label;
                                                setDados({ ...dados });
                                            }}
                                            options={OPCOES_TRANSFER}
                                        />
                                    </FinField>
                                    <FinField label="Descrição do Transfer (se preenchido, sobrepõe o texto padrão do evento)" full>
                                        <FinTextarea id="transferdescricao"
                                            value={dados.participante?.transferdescricao ?? ""}
                                            onChange={(e) => setDados({ ...dados, participante: { ...dados.participante, transferdescricao: e.target.value } })}
                                        />
                                    </FinField>
                                    <FinField label="Observação Transfer" full>
                                        <FinTextarea id="transferobservacao"
                                            value={dados.participante?.transferobservacao ?? ""}
                                            onChange={(e) => { dados.participante.transferobservacao = e.target.value; setDados({ ...dados }); }}
                                        />
                                    </FinField>
                                </div>
                                <div style={{ borderTop: '1px solid var(--fin-border)', margin: '12px 0' }} />
                                <div className="fin-pp__filters">
                                    <FinField label="Possui Transfer Extra?">
                                        <ReactSelect
                                            value={{ value: dados.participante?.transferextra ?? "", label: dados.participante?.nomeTransferextra }}
                                            onChange={(e) => {
                                                dados.participante.transferextra = e.value;
                                                dados.participante.nomeTransferextra = e.label;
                                                setDados({ ...dados });
                                            }}
                                            options={OPCOES_TRANSFER}
                                        />
                                    </FinField>
                                    <FinField label="Descrição do Transfer Extra (se preenchido, sobrepõe o texto padrão do evento)" full>
                                        <FinTextarea id="transferextradescricao"
                                            value={dados.participante?.transferextradescricao ?? ""}
                                            onChange={(e) => setDados({ ...dados, participante: { ...dados.participante, transferextradescricao: e.target.value } })}
                                        />
                                    </FinField>
                                    <FinField label="Observação Transfer Extra" full>
                                        <FinTextarea id="transferextraobservacao"
                                            value={dados.participante?.transferextraobservacao ?? ""}
                                            onChange={(e) => { dados.participante.transferextraobservacao = e.target.value; setDados({ ...dados }); }}
                                        />
                                    </FinField>
                                </div>
                            </div>
                        )}

                        {/* ── Aba: Observações ── */}
                        {tab === 'observacao' && (
                            <div className="fin-pp__filters">
                                <FinField label="Observações Importantes" full>
                                    <FinTextarea id="observacao"
                                        value={dados.participante?.observacao ?? ""}
                                        onChange={(e) => { dados.participante.observacao = e.target.value; setDados({ ...dados }); }}
                                    />
                                </FinField>
                            </div>
                        )}
                    </div>

                    {/* ── BOTÃO SALVAR ── */}
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
                        <button type="submit" className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--pill" disabled={isSubmitting}>
                            {isSubmitting ? 'Salvando...' : <><FaSave size={14} style={{ marginRight: 6 }} />Salvar</>}
                        </button>
                    </div>
                </form>

                {/* ── HISTÓRICO ── */}
                <div className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 16 }}>
                    <div className="fin-pp__cphead">
                        <span className="fin-pp__cphead-ic"><FaHistory size={15} /></span>
                        <span className="fin-pp__cphead-title">Dados de Histórico</span>
                    </div>

                    <form onSubmit={(e) => {
                        //valida se tem status
                        var modalsituacao = document.querySelector("#modalsituacao");
                        if (dadosModalHistorico.situacao === undefined || dadosModalHistorico.situacao === null || dadosModalHistorico.situacao === '') {
                            toast.error('É necessário preencher o status');
                            setTimeout(() => {
                                modalsituacao.focus();
                            }, 500);
                            e.preventDefault();
                            return false;
                        }

                        //valida se tem data e hora da situação
                        var campodatanotificacao = document.querySelector("#datanotificacao");
                        var campohoranotificacao = document.querySelector("#horanotificacao");
                        if (dadosModalHistorico.pedirdata === "sim") {
                            if (dadosModalHistorico.datanotificacao === undefined || dadosModalHistorico.datanotificacao === null || dadosModalHistorico.datanotificacao === '') {
                            } else {
                                if (dadosModalHistorico.horanotificacao === undefined || dadosModalHistorico.horanotificacao === null || dadosModalHistorico.horanotificacao === '') {
                                    toast.error('É necessário preencher a hora');
                                    setTimeout(() => {
                                        campohoranotificacao.focus();
                                    }, 500);
                                    e.preventDefault();
                                    return false;
                                }
                            }
                        }

                        var datanotificacao = null;
                        var horanotificacao = null;
                        if (dadosModalHistorico.datanotificacao !== undefined && dadosModalHistorico.datanotificacao !== null && dadosModalHistorico.datanotificacao !== '') {
                            datanotificacao = dataMysql(dadosModalHistorico.datanotificacao);
                            if (dadosModalHistorico.horanotificacao !== undefined && dadosModalHistorico.horanotificacao !== null && dadosModalHistorico.horanotificacao !== '') {
                                horanotificacao = dadosModalHistorico.horanotificacao;
                            }
                        }

                        //tem observação
                        api({
                            method: 'post',
                            action: '/participanteHistoricoSituacao',
                            token: token,
                            data: {
                                evento: dados.participante.evento.id,
                                participante: dados.participante?.id,
                                situacao: dadosModalHistorico.situacao,
                                historico: dadosModalHistorico.historico,
                                datanotificacao: datanotificacao,
                                horanotificacao: horanotificacao,
                            }
                        })
                            .then(function (response) {
                                //limpa campos
                                dadosModalHistorico.pedirdata = "nao";
                                dadosModalHistorico.datanotificacao = null;
                                dadosModalHistorico.horanotificacao = '';
                                dadosModalHistorico.historico = '';
                                dadosModalHistorico.situacao = null;
                                dadosModalHistorico.nomeSituacao = null;
                                setDadosModalHistorico({ ...dadosModalHistorico });
                                // a mudança de situação faz update no participante e avança o updated_at — recarrega o participante atual
                                // (o helper já refaz o histórico internamente) pra refletir a situação nova + renovar a trava, sem sair do participante
                                recarregarParticipanteAtual(dados.participante?.id);
                                toast.success("Registrado com sucesso!");
                            })
                            .catch(function (error) {
                                toast.error('Erro: ' + (error.response?.data?.error ?? " ao carregar dados"));
                            });
                        e.preventDefault();
                    }}>
                        <div className="fin-pp__filters">
                            <FinField label="Status">
                                <ReactSelect
                                    id="modalsituacao"
                                    value={{ value: dadosModalHistorico.situacao, label: dadosModalHistorico.nomeSituacao, pedirdata: dadosModalHistorico.pedirdata }}
                                    onChange={(e) => {
                                        dadosModalHistorico.situacao = e.value;
                                        dadosModalHistorico.nomeSituacao = e.label;
                                        dadosModalHistorico.pedirdata = e.pedirdata;
                                        setDadosModalHistorico({ ...dadosModalHistorico });
                                    }}
                                    loadOptions={(input) => {
                                        return api({
                                            method: 'get',
                                            action: '/eventoParticipanteSituacao',
                                            token: token,
                                            params: { situacaoRegistro: "ativo", nome: input }
                                        })
                                            .then(response => {
                                                let options = response.data.data.map(registro => ({ value: registro.id, label: registro.nome, pedirdata: registro.pedirdata }));
                                                return options;
                                            })
                                            .catch(function (error) {
                                                //console.log(error);
                                            });
                                    }}
                                />
                            </FinField>
                            {(dadosModalHistorico.pedirdata === "sim") && <>
                                <Data
                                    title="Opcional"
                                    id={"datanotificacao"}
                                    label="Data"
                                    value={dadosModalHistorico.datanotificacao ?? ""}
                                    onChange={(date) => {
                                        dadosModalHistorico.datanotificacao = date;
                                        setDadosModalHistorico({ ...dadosModalHistorico });
                                    }}
                                />
                                <FinField label="Hora">
                                    <InputMask
                                        title="Opcional"
                                        mask="99:99"
                                        className="fin-pp__input"
                                        id="horanotificacao"
                                        value={dadosModalHistorico.horanotificacao ?? ""}
                                        onChange={(e) => {
                                            dadosModalHistorico.horanotificacao = e.target.value;
                                            setDadosModalHistorico({ ...dadosModalHistorico });
                                        }}
                                        style={{ paddingLeft: 14 }}
                                    />
                                </FinField>
                            </>}
                            <FinField label="Observação">
                                <FinTextarea
                                    id="modalhistorico"
                                    value={dadosModalHistorico.historico}
                                    onChange={(e) => {
                                        dadosModalHistorico.historico = e.target.value;
                                        setDadosModalHistorico({ ...dadosModalHistorico });
                                    }}
                                />
                            </FinField>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 10 }}>
                            <button type="submit" className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--pill">
                                <FaSave size={14} style={{ marginRight: 6 }} />Criar Observação
                            </button>
                        </div>
                    </form>

                    {/* Tabela de histórico */}
                    <TabelaHistoricoParticipante historico={historico} setHistorico={setHistorico} token={token} idParticipante={dados.participante?.id} situacao={dados.participante?.situacaoevento} carregando={carregandoHistorico} />
                </div>

            </div>

            <ModalForcarEnvio
                show={forcarEnvio.show}
                mensagem={forcarEnvio.mensagem}
                onFechar={() => setForcarEnvio({ show: false, mensagem: '', reenviar: null })}
                onConfirmar={() => {
                    const reenviar = forcarEnvio.reenviar;
                    setForcarEnvio({ show: false, mensagem: '', reenviar: null });
                    if (reenviar) reenviar();
                }}
            />
        </ErpTemplate>
    );
}
